declare const bootstrap: any;
import {
  AfterViewInit,
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  createComponent,
  ElementRef,
  EmbeddedViewRef,
  HostListener,
  NgZone,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { AdvancedMapPinComponent } from './advanced-map-pin/advanced-map-pin.component';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MapInfoWindowComponent } from './map-info-window/map-info-window.component';
import { BuildingService } from '../../services/building.service';
import { PoleService } from '../../services/pole.service';
import { DtService } from '../../services/dt.service';
import {
  AdvancedMapBounds,
  AdvancedMapClustering,
  AdvancedMapFilter,
  AdvancedMapPinType,
  AdvancedMapSearchType,
  AdvanceMapAnalyticsCounts,
} from '../../models/advancedMap.model';
import { BuildingMapDto } from '../../models/building-map.model';
import { DtMapDto } from '../../models/dt-map.model';
import { PoleMapDto, PolePopupDto } from '../../models/pole-map.model';
import {
  map_polyline_options,
  MAP_THEMES,
  MapThemeUI,
} from '../../models/mapOptions.model';
import { MapConfig } from '../../models/mapConfig.model';
import { DashboardService } from '../../services/dashboard.service';
import { AdvancedMapService } from '../../services/advanced-map.service';
import { Coordinates } from '../../models/coordinates.model';
import { AssetDropdownOption } from '../../models/asset-dropdown-option.model';
import { FilterAssetType } from '../../enums/filter-asset-type.enum';
import { MapConfiguration } from '../../models/utility.model';
import { AiUploadBatchObjectsService } from '../../services/ai-upload-batch-objects.service';
import { PermissionsService, Filter, SubstationTemplateDto, SubstationTemplateService, TaggedSubstationService, CimSubstationService, AcLineSegmentService } from 'shared-lib';
import { UtilityService } from '../../services/utility.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-advanced-map',
  templateUrl: './advanced-map.component.html',
  styleUrls: ['./advanced-map.component.scss'],
  standalone: false,
})
export class AdvancedMapComponent implements OnInit, AfterViewInit {
  constructor(
    private dashboardService: DashboardService,
    private advancedMapService: AdvancedMapService,
    private viewContainerRef: ViewContainerRef,
    private buildingService: BuildingService,
    private poleService: PoleService,
    private dtService: DtService,
    private toastr: ToastrService,
    private appRef: ApplicationRef,
    private batchObjService: AiUploadBatchObjectsService,
    private ngZone: NgZone,
    private permissionService: PermissionsService,
    private utilityService: UtilityService,
    private substationTemplateService: SubstationTemplateService,
    private taggedSubstationService: TaggedSubstationService,
    private cimSubstationService: CimSubstationService,
    private acLineSegmentService: AcLineSegmentService,
    private authService: AuthService
  ) {
      this.utilityId = Number(localStorage.getItem("utilityId"));   
      this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
      if (!this.hasCimDataIntegration) {
        const feedersIndex = this.analyticsData.findIndex((x) => x.key === 'ADVANCED_MAP.FEEDERS');
        this.analyticsData.splice(feedersIndex, 0, { key: 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.DISTRIBUTION_SUBSTATION', share: 0 });
        this.analyticsColors.splice(feedersIndex, 0, this.analyticsCounts.dtAnalytics.color);

        const equipmentIndex = this.analyticsData.findIndex((x) => x.key === 'ADVANCED_MAP.EQUIPMENT');
        this.analyticsData.splice(equipmentIndex, 0,
          { key: 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.INJECTION_SUBSTATION', share: 0 },
          { key: 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.TRANSMISSION_STATION', share: 0 });
        this.analyticsColors.splice(equipmentIndex, 0, this.analyticsCounts.substationAnalytics.color, this.analyticsCounts.tsAnalytics.color);
      }
  }

  hasCimDataIntegration: boolean = false;

  utilityAcronym: string;
  dtSubstationTemplateId: number;
  filter: Filter;
  dtCimSubstationsCount: number = 0;

  currentMapType: 'roadmap' | 'hybrid' = 'hybrid';
  isOnMap: boolean = true;
  isAiOnMap: boolean = false;
  utilityId: number;

  filterOpened: boolean = false;
  searchOpened: boolean = false;
  isBatchObjects: boolean = false;

  analyticsOpened: boolean = true;

  mapFilter: AdvancedMapFilter = new AdvancedMapFilter();
  analyticsCounts: AdvanceMapAnalyticsCounts = new AdvanceMapAnalyticsCounts();

  mapPolylineOptions: any = map_polyline_options;
  renderMap: boolean = true;
  renderTree: boolean = false;
  renderSchematic: boolean = false;
  showPopup: boolean = false;
  defaultConfig: MapConfig = new MapConfig(19);
  currentMapView: AdvancedMapBounds;
  dtsForMap: any[] = [];
  buildingsForMap: any[] = [];
  polesForMap: any[] = [];
  cimSubstationsForMap: { [key: string]: any[] } = {};
  batchObjectsForMap: any[] = [];
  previousZoom: number;

  pinOverlays: google.maps.OverlayView[] = [];
  poleMarkers: google.maps.Marker[] = [];
  polylineObjects: google.maps.Polyline[] = [];

  poleLayerMarkers: { [layer: string]: google.maps.Marker[] } = { hv: [], mv: [], lv: [] };
  lineLayerPolylines: { [layer: string]: google.maps.Polyline[] } = { hv: [], mv: [], lv: [] };
  poleLayerClusterPins: { [layer: string]: HTMLElement[] } = { hv: [], mv: [], lv: [] };
  polesVisible: { [layer: string]: boolean } = { hv: false, mv: false, lv: false };
  linesVisible: { [layer: string]: boolean } = { hv: false, mv: false, lv: false };

  buildingMapDetails?: BuildingMapDto;
  dtMapDetails?: DtMapDto;
  poleMapDetails?: PoleMapDto;
  selectedMapAssetType?: AdvancedMapPinType;
  advancedMapSearchType = AdvancedMapSearchType;
  popupAssetId: number;
  selectedImageUrl: string = '';
  batchObjectDetails?: any;
  appliedFilters: { id: number; label: string; value: string }[] = [];

  coordinatesCopied: boolean = false;
  selectedDtIds: number[] = [];
  themeMenuOpen: boolean = false;
  selectedTheme: any = MAP_THEMES.find((t) => t.key == 'retro');
  mapOptions: any = MAP_THEMES.find((t) => t.key == 'retro')?.mapOptions;
  themes = MAP_THEMES;

  @ViewChild('streetViewContainer', { static: false })
  streetViewContainer!: ElementRef;
  streetViewPanorama?: google.maps.StreetViewPanorama;
  showStreetView: boolean = true;
  fullStreetViewVisible: boolean = false;

  advancedMapClustering: AdvancedMapClustering = new AdvancedMapClustering();

  // Search
  searchIconVisible: boolean = true;
  searchTypeOpened: boolean = false;
  assetNameSearchOptionsExpanded: boolean = false;
  assetSlrnSearchOptionsExpanded: boolean = false;
  searchTypeLabel: string = 'COMMON.SEARCH_TYPE';
  searchType: AdvancedMapSearchType = AdvancedMapSearchType.None;
  searchText: string = '';
  stations: AssetDropdownOption[] = [];
  filteredStations: AssetDropdownOption[] = [];
  searchDebounceTimer: any;
  searchDropdownOptionsVisible: boolean = false;
  count: number = 5;
  isAccNo: boolean = false;
  isDtSlrn: boolean = false;
  isMeterNumber: boolean = false;
  option: number;
  isBuildingSlrn: boolean = false;
  isNetworkAsset: boolean = false;
  isLvPoleSlrn: boolean = false;
  isMeterSlrn: boolean = false;
  isCimSubstationTemplate: boolean = false;
  selectedCimSubstationTemplateId: number = 0;
  isCimAcLine: boolean = false;
  selectedCimAcLineType: number = 0;
  isLocation: boolean = false;
  autocompleteInitialized: boolean = false;
  @ViewChild('locationInput') locationInput!: ElementRef;

  @ViewChild('modalMap') modalMap!: GoogleMap;
  modalMapConfig: MapConfig = new MapConfig(20);
  assetsForModal: any[] = [];
  lvPolePopup!: PolePopupDto;
  bounds!: {
    minLatitude: number;
    maxLatitude: number;
    minLongitude: number;
    maxLongitude: number;
  };
  pendingPoleId: number | null = null;
  confirmationMode: 'connect' | 'remove' | null = null;
  modalMapOptions: any = MAP_THEMES.find((t) => t.key == 'retro')?.mapOptions;
  modalPinOverlays: google.maps.OverlayView[] = [];
  modalPolylineObjects: google.maps.Polyline[] = [];
  locationChanged: boolean = false;
  modifiedAssetIds: number[] = [];
  tempConnectionLines: google.maps.Polyline[] = [];

  @ViewChild(GoogleMap) map!: GoogleMap;

  private activeInfoWindow: google.maps.InfoWindow | null = null;
  private polylineInfoWindow = new google.maps.InfoWindow();

  private mapChangeTimeout: any;
  private previousBounds: AdvancedMapBounds | null = null;

  private readonly radius = 14;

  private selectedButton = 'map-btn';

  hoveredItem: any = null;

  dtsReady: boolean = false;
  buildingsReady: boolean = false;
  polesReady: boolean = false;
  cimSubstations: boolean = false;

  analyticsColors = [
    '#479A3F',
    '#BCBC03',
    '#6C2E40',
    '#083F72',
    '#6922DB',
  ];

  analyticsData = [
    { key: 'COMMON.CUSTOMER.PLURAL', share: 0 },
    { key: 'COMMON.BUILDING.PLURAL', share: 0 },
    { key: 'COMMON.POLE.PLURAL', share: 0 },
    { key: 'ADVANCED_MAP.FEEDERS', share: 0 },
    { key: 'ADVANCED_MAP.EQUIPMENT', share: 0 },
  ];
  generatedObjectUrl: string | null = null;

  ngOnInit() {
    this.isAiOnMap = this.permissionService.hasDashboardConfigAIDroneMap;
    this.getDefaultCoordinates(true);
    this.getAssetCounts();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.map && this.map.googleMap) {
        this.map.googleMap.addListener(
          'click',
          (event: google.maps.MapMouseEvent) => {
            if (event.latLng) {
              this.closePopup();
              this.closeThemeMenu();
            }
          }
        );
      }
    }, 700);
  }

  get totalValue(): number {
    return (
      (this.analyticsCounts.buildingAnalytics?.count || 0) +
      (this.analyticsCounts.customerAnalytics?.count || 0) +
      (this.analyticsCounts.dtAnalytics?.count || 0) +
      (this.analyticsCounts.poleAnalytics?.count || 0) +
      (this.analyticsCounts.substationAnalytics?.count || 0) +
      (this.analyticsCounts.tsAnalytics?.count || 0) +
      (this.analyticsCounts.feederAnalytics?.count || 0) +
      (this.analyticsCounts.deviceAnalytics?.count || 0) +
      this.analyticsCounts.cimSsCounts.reduce((sum, x) => sum + (x.count || 0), 0)
    );
  }

  getDashArray(value: number): string {
    const total = this.totalValue;
    if (total === 0) return '0 0';

    const circumference = 2 * Math.PI * this.radius;
    const gapRatio = 0.004;
    const percent = value / total;
    const visible = Math.max(0, percent - gapRatio) * circumference;
    const hidden = circumference - visible;

    return `${visible} ${hidden}`;
  }

  getDashOffset(index: number): number {
    const items = [
      this.analyticsCounts.buildingAnalytics?.count || 0,
      this.analyticsCounts.customerAnalytics?.count || 0,
      this.analyticsCounts.dtAnalytics?.count || 0,
      this.analyticsCounts.poleAnalytics?.count || 0,
      this.analyticsCounts.substationAnalytics?.count || 0,
      this.analyticsCounts.feederAnalytics?.count || 0,
      this.analyticsCounts.tsAnalytics?.count || 0,
      this.analyticsCounts.deviceAnalytics?.count || 0
    ];

    const total = this.totalValue;
    if (total === 0) return 0;

    const circumference = 2 * Math.PI * this.radius;

    let sum = 0;
    for (let i = 0; i < index; i++) {
      sum += items[i];
    }

    return -(sum / total) * circumference;
  }

  get analyticsDataArray() {
    return [
      {
        value: this.analyticsCounts.buildingAnalytics?.count || 0,
        color: this.analyticsCounts.buildingAnalytics?.color,
      },
      {
        value: this.analyticsCounts.customerAnalytics?.count || 0,
        color: this.analyticsCounts.customerAnalytics?.color,
      },
      {
        value: this.analyticsCounts.dtAnalytics?.count || 0,
        color: this.analyticsCounts.dtAnalytics?.color,
      },
      {
        value: this.analyticsCounts.poleAnalytics?.count || 0,
        color: this.analyticsCounts.poleAnalytics?.color,
      },
    ];
  }

  getPoleMarkerSVG(color: string): string {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
        <defs>
          <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
            <feDropShadow dx="0" dy="1.26" stdDeviation="1.26" flood-color="black" flood-opacity="0.25" />
          </filter>
        </defs>
        <circle cx="12" cy="12" r="${this.getZoomScaledValue(6,9, this.defaultConfig.zoom)}" fill="${color}" stroke="white" stroke-width="2" filter="url(#shadow)" />
      </svg>
    `;
  }

  addPoleMarker(
    lat: number,
    lng: number,
    id: number,
    advType: AdvancedMapPinType,
    color: string = '#FFC800'
  ) {
    const svg = this.getPoleMarkerSVG(color);
    const encoded =
      'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
    const layer = this.getPoleLayer(color);

    const marker = new google.maps.Marker({
      position: { lat, lng },
      map: this.polesVisible[layer] ? this.map.googleMap! : null,
      icon: {
        url: encoded,
        scaledSize: new google.maps.Size(16, 16),
        anchor: new google.maps.Point(8, 8),
      },
    });

    marker.addListener('click', async () => {
      if (this.activeInfoWindow) {
        this.activeInfoWindow.close();
        this.activeInfoWindow = null;
      }

      this.checkAndInitStreetView(lat, lng);

      const modalComponentRef = createComponent(MapInfoWindowComponent, {
        environmentInjector: this.appRef.injector,
      });

      modalComponentRef.instance.editLocation.subscribe((lvPolePupup) => {
        this.openLvPolesMapModal(lvPolePupup);
      });

      modalComponentRef.instance.generatedObjectUrl.subscribe((url: string) => {
        this.generatedObjectUrl = url;
      });

      const poleId = id;
      modalComponentRef.instance.assetId = poleId;
      modalComponentRef.instance.type = advType;
      this.popupAssetId = poleId;

      this.appRef.attachView(modalComponentRef.hostView);
      modalComponentRef.changeDetectorRef.detectChanges();

      modalComponentRef.instance.actionClicked.subscribe(() => {
        this.getMapFullDetails(poleId, advType);
      });

      modalComponentRef.instance.closeWindow.subscribe(() => {
        if (this.activeInfoWindow) {
          this.activeInfoWindow.close();
          modalComponentRef.destroy();
          this.activeInfoWindow = null;
        }
      });

      modalComponentRef.instance.copyCoordinates.subscribe(() => {
        const coordinates = `${lat}, ${lng}`;
        navigator.clipboard
          .writeText(coordinates)
          .then(() => {})
          .catch((err) => {});
      });

      const domElem = (modalComponentRef.hostView as EmbeddedViewRef<any>)
        .rootNodes[0] as HTMLElement;

      document.body.appendChild(domElem);
      await this.waitForElementToRender(domElem);

      const infoWindow = new google.maps.InfoWindow({
        content: domElem,
        position: { lat, lng },
        headerDisabled: true,
        disableAutoPan: false,
      });

      infoWindow.open(this.map.googleMap);
      this.activeInfoWindow = infoWindow;
      domElem.remove();

      google.maps.event.addListener(this.map.googleMap!, 'click', () => {
        if (this.activeInfoWindow) {
          this.activeInfoWindow.close();
          modalComponentRef.destroy();
          this.activeInfoWindow = null;
        }
        this.hideStreetView();
      });
    });

    this.poleMarkers.push(marker);
    this.poleLayerMarkers[layer].push(marker);
  }

  getPoleLayer(color: string) {
    if (color == '#94D02C') return 'mv';
    if (color == '#F06BFF') return 'hv';
    return 'lv';
  }

  addPoleClusterPin(layer: string, element: HTMLElement) {
    element.style.display = this.polesVisible[layer] ? '' : 'none';
    this.poleLayerClusterPins[layer].push(element);
  }

  onPolesToggled(layer: string, event: Event) {
    this.polesVisible[layer] = (event.target as HTMLInputElement).checked;
    const map = this.polesVisible[layer] ? this.map.googleMap! : null;
    for (let marker of this.poleLayerMarkers[layer]) {
      marker.setMap(map);
    }
    for (let element of this.poleLayerClusterPins[layer]) {
      element.style.display = this.polesVisible[layer] ? '' : 'none';
    }
  }

  onLinesToggled(layer: string, event: Event) {
    this.linesVisible[layer] = (event.target as HTMLInputElement).checked;
    const map = this.linesVisible[layer] ? this.map.googleMap! : null;
    for (let polyline of this.lineLayerPolylines[layer]) {
      polyline.setMap(map);
    }
  }

  checkIfActiveInfoWindowIsInView(
    maxLat: number,
    minLat: number,
    maxLng: number,
    minLng: number,
    currLng: number,
    currLat: number
  ) {
    return (
      currLat >= minLat &&
      currLat <= maxLat &&
      currLng <= maxLng &&
      currLng >= minLng
    );
  }

  addCustomPin(
    id: number,
    lat: number,
    lng: number,
    type: AdvancedMapPinType,
    connectedCustomers?: number,
    clusterCount?: number
  ) {
    const componentRef = this.viewContainerRef.createComponent(
      AdvancedMapPinComponent
    );
    //PIN STYLES
    if (type == AdvancedMapPinType.Dt) {
      componentRef.instance.inputIsCluster =
        this.advancedMapClustering.useClusteringDts;
      componentRef.instance.inputColor = '#005EFF';
      componentRef.instance.inputImg = '../../assets/icons/adv-map-pin-dt.svg';
      componentRef.instance.inputType = 'DT';
      componentRef.instance.inputClusterCount = clusterCount?.toString() ?? '';
    } else if (type == AdvancedMapPinType.Building) {
      componentRef.instance.inputIsCluster =
        this.advancedMapClustering.useClusteringBuildings;
      var connCustomers = connectedCustomers?.toString();
      connectedCustomers != 0
        ? (componentRef.instance.inputText = connCustomers!)
        : (componentRef.instance.inputText = 'NO');
      componentRef.instance.inputColor = '#009E51';
      componentRef.instance.inputType = 'B/C';
      componentRef.instance.inputImg =
        '../../assets/icons/adv-map-pin-building.svg';
      componentRef.instance.inputClusterCount = clusterCount?.toString() ?? '';
    } else if (type == AdvancedMapPinType.Pole) {
      componentRef.instance.inputIsCluster =
        this.advancedMapClustering.useClusteringPoles;
      componentRef.instance.inputColor = '#FFC800';
      componentRef.instance.inputImg =
        '../../assets/icons/adv-map-pin-lv-pole.svg';
      componentRef.instance.inputClusterCount = clusterCount?.toString() ?? '';
      this.addPoleClusterPin('lv', componentRef.location.nativeElement);
    } else if (type == AdvancedMapPinType.CimInjectionSubstation) {
      componentRef.instance.inputIsCluster =
        this.advancedMapClustering.useClusteringSubstations;
      componentRef.instance.inputColor = '#ED6B00';
      componentRef.instance.inputImg =
        '../../assets/icons/adv-map-pin-is.svg';
      componentRef.instance.inputClusterCount = clusterCount?.toString() ?? '';
    } else if (type == AdvancedMapPinType.CimTransmissionStation) {
      componentRef.instance.inputIsCluster =
        this.advancedMapClustering.useClusteringSubstations;
      componentRef.instance.inputColor = '#7A28FF';
      componentRef.instance.inputImg =
        '../../assets/icons/map-legend-ts.svg';
      componentRef.instance.inputClusterCount = clusterCount?.toString() ?? '';
    } else if (type == AdvancedMapPinType.CimDistributionSubstation) {
      componentRef.instance.inputIsCluster =
        this.advancedMapClustering.useClusteringSubstations;
      componentRef.instance.inputColor = '#005EFF';
      componentRef.instance.inputImg =
        '../../assets/icons/adv-map-pin-dt.svg';
      componentRef.instance.inputClusterCount = clusterCount?.toString() ?? '';
    }

    const overlay = new google.maps.OverlayView();

    overlay.onAdd = () => {
      const panes = overlay.getPanes();
      const element = componentRef.location.nativeElement;
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      panes!.overlayMouseTarget.appendChild(element);

      element.addEventListener('click', async (event: any) => {
        event?.stopPropagation();

        if (this.activeInfoWindow) {
          this.activeInfoWindow.close();
          this.activeInfoWindow = null;
        }

        if ((type == AdvancedMapPinType.Building && !this.advancedMapClustering.useClusteringBuildings) ||
           ((type == AdvancedMapPinType.Dt) && !this.advancedMapClustering.useClusteringDts) ||
           ((type == AdvancedMapPinType.CimTransmissionStation) && !this.advancedMapClustering.useClusteringSubstations) ||
           ((type == AdvancedMapPinType.CimInjectionSubstation) && !this.advancedMapClustering.useClusteringSubstations) ||
           ((type == AdvancedMapPinType.CimDistributionSubstation) && !this.advancedMapClustering.useClusteringSubstations)
        ) {
          this.checkAndInitStreetView(lat, lng);
          const modalComponentRef = createComponent(MapInfoWindowComponent, {
            environmentInjector: this.appRef.injector,
          });

          modalComponentRef.instance.assetId = id;
          modalComponentRef.instance.type = type;
          this.popupAssetId = id;
          this.appRef.attachView(modalComponentRef.hostView);
          modalComponentRef.changeDetectorRef.detectChanges();

          // Display full details on button click
          modalComponentRef.instance.actionClicked.subscribe(() => {
            this.getMapFullDetails(id, type);
          });

          // Close modal on X click
          modalComponentRef.instance.closeWindow.subscribe(() => {
            if (this.activeInfoWindow) {
              this.activeInfoWindow.close();
              modalComponentRef.destroy();
              this.activeInfoWindow = null;
            }
          });

          // Copy coordinates click
          modalComponentRef.instance.copyCoordinates.subscribe(() => {
            const coordinates = `${lat}, ${lng}`;
            navigator.clipboard
              .writeText(coordinates)
              .then(() => {})
              .catch((err) => {});
          });

          this.appRef.attachView(modalComponentRef.hostView);
          const domElem = (modalComponentRef.hostView as EmbeddedViewRef<any>)
            .rootNodes[0] as HTMLElement;

          document.body.appendChild(domElem);
          await this.waitForElementToRender(domElem);

          const infoWindow = new google.maps.InfoWindow({
            content: domElem,
            position: { lat, lng },
            headerDisabled: true,
            disableAutoPan: false,
          });

          infoWindow.open(this.map.googleMap);
          this.activeInfoWindow = infoWindow;
          domElem.remove();

          google.maps.event.addListener(this.map.googleMap!, 'click', () => {
            if (this.activeInfoWindow) {
              this.hideStreetView();
              this.activeInfoWindow.close();
              modalComponentRef.destroy();
              this.activeInfoWindow = null;
            }
          });
        } else {
          this.defaultConfig.zoom += 4;
          this.defaultConfig.coordinates.latitude = lat;
          this.defaultConfig.coordinates.longitude = lng;
        }
      });
    };

    overlay.draw = () => {
      const projection = overlay.getProjection();
      if (!projection) return;

      const position = new google.maps.LatLng(lat, lng);
      const point = projection.fromLatLngToDivPixel(position);
      if (!point) return;

      const div = componentRef.location.nativeElement;
      div.style.left = `${point.x - div.offsetWidth / 2}px`;
      div.style.top = `${point.y - div.offsetHeight}px`;
      div.style.visibility = 'visible';
    };

    overlay.onRemove = () => {
      if (
        componentRef.location &&
        componentRef.location.nativeElement?.parentNode
      ) {
        componentRef.location.nativeElement.parentNode.removeChild(
          componentRef.location.nativeElement
        );
      }
      componentRef.destroy();
    };

    overlay.setMap(this.map.googleMap!);
    this.pinOverlays.push(overlay);
  }

  waitForElementToRender(el: HTMLElement): Promise<void> {
    return new Promise((resolve) => {
      const check = () => {
        const visible = el.offsetWidth > 50 && el.offsetHeight > 50;
        if (visible) {
          resolve();
        } else {
          requestAnimationFrame(check);
        }
      };
      check();
    });
  }

  switchMap() {
    this.analyticsOpened = false;
    this.mapFilter.selectedAreas = [];
    this.mapFilter.selectedDts = [];
    this.mapFilter.selectedBuildings = [];
    this.mapFilter.selectedCimSubstations = [];
    this.mapFilter.selectedSubGeographicalRegions = [];
    this.appliedFilters = [];
    this.activeInfoWindow?.close();

    this.closeMapDetailsModal();
    this.closePopup();
    this.closeThemeMenu();
    this.getData();
  }
  removeAllPins() {
    for (let overlay of this.pinOverlays) {
      if (overlay) {
        overlay.setMap(null);
      }
    }
    this.pinOverlays = [];

    for (let marker of this.poleMarkers) {
      marker.setMap(null);
    }
    this.poleMarkers = [];

    for (let path of this.polylineObjects) {
      path.setMap(null);
    }
    this.polylineObjects = [];

    this.poleLayerMarkers = { hv: [], mv: [], lv: [] };
    this.lineLayerPolylines = { hv: [], mv: [], lv: [] };
    this.poleLayerClusterPins = { hv: [], mv: [], lv: [] };
  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closePopup();
      this.closeThemeMenu();
    }
  }

  switchButtonClicked(buttonClass: string) {
    if (buttonClass == 'map-btn' && buttonClass != this.selectedButton) {
      this.selectedButton = 'map-btn';
      this.isOnMap = true;
      this.isBatchObjects = false;
      this.renderTree = false;
      this.renderMap = true;
      this.renderSchematic = false;

      this.loadMapConfiguration();
      this.switchMap();
      this.analyticsOpened = true;
    }
    else if(buttonClass == 'tree-btn' && buttonClass != this.selectedButton) {
      this.selectedButton = 'tree-btn';
      this.isOnMap = false;
      this.isBatchObjects = false;
      this.renderTree = true;
      this.renderMap = false;
      this.renderSchematic = false;
      this.filterOpened = false;
      this.searchOpened = false;
      this.searchIconVisible = true;
      this.searchTypeOpened = false;
      this.analyticsOpened = false;
    } else if(buttonClass == 'schematic-btn' && buttonClass != this.selectedButton) {
      this.selectedButton = 'schematic-btn';
      this.isOnMap = false;
      this.renderMap = false;
      this.renderTree = false;
      this.renderSchematic = true;
      this.filterOpened = false;
      this.searchOpened = false;
      this.analyticsOpened = false;
    }
  }

  closePopup() {
    if (this.themeMenuOpen) this.themeMenuOpen = false;
    this.showPopup = false;
  }

  togglePopup() {
    if (this.themeMenuOpen) this.themeMenuOpen = false;
    this.showPopup = !this.showPopup;
  }

  getDefaultCoordinates(init: boolean = false) {
    const mapConfig = localStorage.getItem('mapConfiguration');
    if (mapConfig && init) {
      try {
        const config = JSON.parse(mapConfig) as MapConfiguration;
        const mapTheme = config.mapTheme || 'retro';
        const mapTypeId = config.mapType || 'hybrid';

        this.selectedTheme = MAP_THEMES.find((t) => t.key == mapTheme);
        this.mapOptions = this.selectedTheme.mapOptions;
        this.mapOptions.mapTypeId = mapTypeId;
        this.defaultConfig.coordinates.latitude = config.latitude;
        this.defaultConfig.coordinates.longitude = config.longitude;
        this.defaultConfig.zoom = config.zoom!;

        if (this.defaultConfig.zoom < 19) {
          this.advancedMapClustering = new AdvancedMapClustering(true);
        }
      } catch (e) {
        this.getCoordinatesWhenNoConfiguration();
      }
    } else {
      this.getCoordinatesWhenNoConfiguration();
    }
  }

  getUtilityAcronymById() {
    
  }

  getDTSubstationTemplateId() {
    
  }

  populateFilterForCimSubstationsCount() {

      const cachedFilters = localStorage.getItem(
        `filterDynamicSubstations|${this.dtSubstationTemplateId}`,
      );
      if (cachedFilters) {
        const parsed = JSON.parse(cachedFilters);
        this.filter = parsed;
        this.filter.substationTemplateId = this.dtSubstationTemplateId;

        localStorage.removeItem(
          `filterDynamicSubstations|${this.dtSubstationTemplateId}`,
        );
      }
  }

  getCoordinatesWhenNoConfiguration() {
    var obj: any = {
      utilityId: 0,
      areasIds: [],
      dtsIds: [],
      cimSubstationsIds: [],
      subGeographicalRegionIds: [],
      hasCimDataIntegration: this.hasCimDataIntegration,
      isAdvancedMap: true,
    };
    if (
      this.mapFilter.selectedAreas.length > 0 ||
      this.mapFilter.selectedDts.length > 0 ||
      this.mapFilter.selectedCimSubstations.length > 0 ||
      this.mapFilter.selectedSubGeographicalRegions.length > 0
    ) {
      obj = {
        utilityId: 0,
        areasIds: this.mapFilter.selectedAreas ?? [],
        dtsIds: this.mapFilter.selectedDts,
        cimSubstationsIds: this.mapFilter.selectedCimSubstations ?? [],
        subGeographicalRegionIds: this.mapFilter.selectedSubGeographicalRegions ?? [],
        hasCimDataIntegration: this.hasCimDataIntegration,
        isAdvancedMap: true, // remove after the demo
      };
    } else if (
      this.mapFilter.mapFilterSingle.buildingId != 0 ||
      this.mapFilter.mapFilterSingle.dtId != 0 ||
      this.mapFilter.mapFilterSingle.poleId != 0
    ) {
      obj = {
        utilityId: 0,
        areasIds: this.mapFilter.selectedAreas ?? [],
        dtsIds: [this.mapFilter.mapFilterSingle.dtId],
        cimSubstationsIds: this.mapFilter.selectedCimSubstations ?? [],
        hasCimDataIntegration: this.hasCimDataIntegration,
        isAdvancedMap: true,
      };
    }
    const singleAsset = this.getSingleSearchAsset();
    if (singleAsset) obj = { ...obj, ...singleAsset };
    const zoomToAsset = this.isSingleAssetSelected();
    this.dashboardService.getDefaultCoordinates(obj).subscribe({
      next: (data: any) => {
        // zoom in only when the backend found the asset's own coordinates, otherwise zoom out as for any other filter
        if (zoomToAsset) this.defaultConfig.zoom = data.body?.isAssetCoordinates ? 20 : 12;
        // Check if there are no coordinates
        if (
          (data.body!.latitude! == null || data.body!.latitude! == 0) &&
          (data.body!.longitude == null || data.body!.latitude! == 0)
        ) {
          this.toastr.info(
            'There is no coordinates for you filter. Try something else.'
          );
          return;
        }
        if (
          this.checkIfMapRefresh(data.body!.latitude!, data.body!.longitude!)
        ) {
          this.defaultConfig.coordinates = new Coordinates(
            data.body!.latitude!,
            data.body!.longitude!
          );
        } else {
          this.defaultConfig.coordinates.latitude! =
            this.defaultConfig.coordinates.latitude! + 0.00000001;
        }
      },
    });
  }

  private getSingleSearchAsset(): { assetId: number; assetType: FilterAssetType } | null {
    const single = this.mapFilter.mapFilterSingle;
    if (single.buildingId) return { assetId: single.buildingId, assetType: FilterAssetType.Building };
    if (single.poleId) return { assetId: single.poleId, assetType: FilterAssetType.Pole };
    if (single.substationId) return { assetId: single.substationId, assetType: FilterAssetType.Substation };
    if (single.cimSubstationId) return { assetId: single.cimSubstationId, assetType: FilterAssetType.CimSubstation };
    return null;
  }

  private isSingleAssetSelected(): boolean {
    return this.getSingleSearchAsset() != null ||
      (!this.hasCimDataIntegration && this.mapFilter.selectedDts.length == 1);
  }
  
  // This method is usefull when assets in view should change (filter), but coordinates remain same, we should check it and refresh map manualy
  private checkIfMapRefresh(lat: any, lng: any) {
    lat = lat ?? 0;
    lng = lng ?? 0;
    if (this.defaultConfig.coordinates == undefined) return true;

    if (
      this.defaultConfig.coordinates.latitude == lat &&
      this.defaultConfig.coordinates.longitude == lng
    )
      return false;
    return true;
  }

  onMapChange() {
    if (this.mapChangeTimeout) {
      clearTimeout(this.mapChangeTimeout);
    }

    this.mapChangeTimeout = setTimeout(() => {
      const bounds = this.map.getBounds();
      if (!bounds) return;

      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();

      const newBounds = new AdvancedMapBounds(
        ne.lng(),
        sw.lng(),
        ne.lat(),
        sw.lat()
      );

      const baseEpsilon = 0.001;
      let epsilon = baseEpsilon / Math.pow(2, (this.defaultConfig.zoom - 12) * 0.55);
      epsilon = Math.max(epsilon, 0.0002);
      
      if (
        this.previousBounds &&
        Math.abs(this.previousBounds.minLatitude - newBounds.minLatitude) < epsilon &&
        Math.abs(this.previousBounds.maxLatitude - newBounds.maxLatitude) < epsilon &&
        Math.abs(this.previousBounds.minLongitude - newBounds.minLongitude) < epsilon &&
        Math.abs(this.previousBounds.maxLongitude - newBounds.maxLongitude) < epsilon
      ) {
        return;
      }

      if (
        !this.checkIfActiveInfoWindowIsInView(
          newBounds.maxLatitude,
          newBounds.minLatitude,
          newBounds.maxLongitude,
          newBounds.minLongitude,
          this.activeInfoWindow?.getPosition()?.lng()!,
          this.activeInfoWindow?.getPosition()?.lat()!
        )
      ) {
        this.activeInfoWindow?.close();
        this.activeInfoWindow = null;
      }

      this.previousBounds = newBounds;
      this.currentMapView = newBounds;
      this.getData();
    }, 200);
  }
  getData() {
    const obj = {
      minLongitude: this.currentMapView.minLongitude,
      maxLongitude: this.currentMapView.maxLongitude,
      minLatitude: this.currentMapView.minLatitude,
      maxLatitude: this.currentMapView.maxLatitude,
      zoom: this.defaultConfig.zoom,
      advancedMapClustering: this.advancedMapClustering,
      utilityId: this.utilityId,
    };
    this.reloadMap(obj);
  }

  reloadMap(obj: any) {
    this.removeAllPins();
    if (this.isAiOnMap) {
      this.getBatchObjectMapData(obj);
    } 
    
    if (!this.hasCimDataIntegration) {
      this.getMapDtData(obj).subscribe({
        next: (dtRes) => {
          this.dtsForMap = dtRes.body.data;
          this.batchObjectsForMap = [];
          this.addDtPinsToMap();
          this.dtsReady = true;
          this.checkIfDataIsReady();
        },
      });
    }

    this.getMapBuildingsData(obj).subscribe({
      next: (buildingsRes) => {
        this.buildingsForMap = buildingsRes.body.data;
        this.batchObjectsForMap = [];
        this.addBuildingsPinsToMap();
        this.buildingsReady = true;
        this.checkIfDataIsReady();
        this.checkIfCimDataIsReady();
      },
    });

    this.getMapPolesData(obj).subscribe({
      next: (poleRes) => {
        this.polesForMap = poleRes.body.data;
        this.batchObjectsForMap = [];
        this.addPolesPinsToMap();
        this.polesReady = true;
        this.checkIfDataIsReady();
        this.checkIfCimDataIsReady();
      },
    });

    if (this.hasCimDataIntegration) {
      this.getMapCimSubstationsData(obj).subscribe({
        next: (cimSubstationsRes) => {
          this.cimSubstationsForMap = cimSubstationsRes.body.data ?? {};
          const cimDss = this.cimSubstationsForMap["CimDistributionSubstation"] || [];
          const cimSs  = this.cimSubstationsForMap["CimInjectionSubstation"] || [];
          const cimTss = this.cimSubstationsForMap["CimTransmissionStation"] || [];
          this.batchObjectsForMap = [];
          this.addCimTransmissionStationsToMap(cimTss);
          this.addCimInjectionSubstationsToMap(cimSs);
          this.addCimDistributionSubstationsToMap(cimDss);
          this.cimSubstations = true;
          this.checkIfCimDataIsReady();
        },
      });
    }
  }

  private checkIfDataIsReady() {
    if (this.dtsReady && this.buildingsReady && this.polesReady) {
      var objectForLines: any = {
        ...this.currentMapView,
        filter: this.mapFilter,
        type: AdvancedMapPinType.Pole,
      };
      if (
        this.mapFilter.mapFilterSingle.buildingId == 0 &&
        this.mapFilter.mapFilterSingle.dtId == 0 &&
        this.mapFilter.mapFilterSingle.poleId == 0
      )
        this.connectAssets(objectForLines);
      this.dtsReady = false;
      this.buildingsReady = false;
      this.polesReady = false;
    } else return;
  }

  private checkIfCimDataIsReady() {
    if (this.cimSubstations && this.buildingsReady && this.polesReady) {
      var objectForLines: any = {
        ...this.currentMapView,
        filter: this.mapFilter,
        type: AdvancedMapPinType.Pole,
      };
      if (
        this.mapFilter.mapFilterSingle.buildingId == 0 &&
        this.mapFilter.mapFilterSingle.dtId == 0 &&
        this.mapFilter.mapFilterSingle.poleId == 0
      )
        this.connectCimAssets(objectForLines);
      this.cimSubstations = false;
      this.buildingsReady = false;
      this.polesReady = false;
    } else return;
  }

  getMapCimSubstationsData(obj: any): Observable<any> {
    const cimSsObj = {
      ...obj,
      filter: this.mapFilter,
      type: AdvancedMapPinType.CimSubstations,
    };

    const cimSubstations = this.advancedMapService.getMapCimData(cimSsObj);
    return cimSubstations;
  }

  addCimTransmissionStationsToMap(cimTransmissionStations: any[]) {
    for (let cimSs of cimTransmissionStations) {
      this.addCustomPin(
        cimSs.id,
        cimSs.latitude,
        cimSs.longitude,
        AdvancedMapPinType.CimTransmissionStation,
        0,
        cimSs.clusterCount
      );
    }
  }

  addCimInjectionSubstationsToMap(cimInjectionSubstations: any[]) {
    for (let cimSs of cimInjectionSubstations) {
      this.addCustomPin(
        cimSs.id,
        cimSs.latitude,
        cimSs.longitude,
        AdvancedMapPinType.CimInjectionSubstation,
        0,
        cimSs.clusterCount
      );
    }
  }

  addCimDistributionSubstationsToMap(cimDistributionSubstations: any[]) {
    for (let cimSs of cimDistributionSubstations) {
      this.addCustomPin(
        cimSs.id,
        cimSs.latitude,
        cimSs.longitude,
        AdvancedMapPinType.CimDistributionSubstation,
        0,
        cimSs.clusterCount
      );
    }
  }

  removeFilter(filter: { id?: number; label: string; value: string }) {
    if (filter.label == 'Area') {
      this.mapFilter.selectedAreas = this.mapFilter.selectedAreas.filter(
        (areaId) => areaId != filter.id
      );
      this.appliedFilters = this.appliedFilters.filter(
        (area) => area.value != filter.value
      );
    } else if (filter.label == 'Dt') {
      this.mapFilter.selectedDts = this.mapFilter.selectedDts.filter(
        (dtId) => dtId != filter.id
      );
      this.appliedFilters = this.appliedFilters.filter(
        (dt) => dt.value != filter.value
      );
    } else if (filter.label == 'Sub Geographical Region') {
      this.mapFilter.selectedSubGeographicalRegions = this.mapFilter.selectedSubGeographicalRegions.filter(
        (subRegionId) => subRegionId != filter.id
      );
      this.appliedFilters = this.appliedFilters.filter(
        (subRegion) => subRegion.value != filter.value
      );
    }

    if (this.appliedFilters.length == 0) this.resetFilter();
  }

  applyFilter() {
    this.getDefaultCoordinates();
    if (this.isSingleAssetSelected()) {
      // zoom is set in getCoordinatesWhenNoConfiguration once the asset's coordinates arrive
    } else if (
      this.mapFilter.selectedAreas.length > 0 ||
      this.mapFilter.selectedDts.length > 0 ||
      this.mapFilter.selectedBuildings.length > 0 ||
      this.mapFilter.selectedCimSubstations.length > 0 ||
      this.mapFilter.selectedSubGeographicalRegions.length > 0 ||
      this.mapFilter.mapFilterSingle.buildingId != 0 ||
      this.mapFilter.mapFilterSingle.dtId ||
      this.mapFilter.mapFilterSingle.poleId
    )
      this.defaultConfig.zoom = 12;
    else this.defaultConfig.zoom = 19;

    if (this.analyticsOpened) {
      this.getAssetCounts();
    }
  }

  resetFilter() {
    this.mapFilter.selectedAreas = [];
    this.mapFilter.selectedDts = [];
    this.mapFilter.selectedBuildings = [];
    this.mapFilter.selectedCimSubstations = [];
    this.mapFilter.selectedSubGeographicalRegions = [];
    this.appliedFilters = [];
    this.applyFilter();
  }

  getMapDtData(obj: any): Observable<any> {
    const dtObj = {
      ...obj,
      filter: this.mapFilter,
      type: AdvancedMapPinType.Dt,
    };

    const dts = this.advancedMapService.getMapData(dtObj);
    return dts;
  }

  getMapBuildingsData(obj: any): Observable<any> {
    const buildingObj = {
      ...obj,
      filter: this.mapFilter,
      type: AdvancedMapPinType.Building,
    };

    const buildings = this.advancedMapService.getMapData(buildingObj);
    return buildings;
  }

  getMapPolesData(obj: any): Observable<any> {
    const poleObj = {
      ...obj,
      filter: this.mapFilter,
      type: AdvancedMapPinType.Pole,
    };

    const poles = this.advancedMapService.getMapData(poleObj);
    return poles;
  }

  getBatchObjectMapData(obj: any) {
    const dataIn = {
      ...obj,
      type: AdvancedMapPinType.BatchObject,
    };
    this.advancedMapService.getMapData(dataIn).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.batchObjectsForMap = responseData.data;
          for (let o of this.batchObjectsForMap) {
            if (
              !this.advancedMapClustering.useClusteringBatchObjects &&
              (o.objectCategory == 'LvPole' ||
                o.objectCategory == 'MvPole' ||
                o.objectCategory == 'HvPole')
            ) {
              this.addPoleMarker(
                o.latitude,
                o.longitude,
                o.id,
                AdvancedMapPinType.BatchObject,
                this.getColor(o.objectCategory)
              );
              continue;
            }
            this.addCustomPinBatchObject(
              o.id,
              o.latitude,
              o.longitude,
              o.objectCategory,
              o.connectedCustomers,
              o.clusterCount
            );
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  initStreetView(lat: number, lng: number) {
    if (!this.streetViewContainer) return;

    this.showStreetView = true;
    this.streetViewPanorama = new google.maps.StreetViewPanorama(
      this.streetViewContainer.nativeElement,
      {
        position: { lat: lat, lng: lng },
        pov: {
          heading: 34,
          pitch: 10,
        },
        zoom: 1,
      }
    );
  }

  hideStreetView(): void {
    this.showStreetView = false;

    if (this.streetViewPanorama) {
      this.streetViewPanorama.setVisible(false);
      this.streetViewPanorama = undefined;
    }
  }

  checkAndInitStreetView(lat: number, lng: number): void {
    const streetViewService = new google.maps.StreetViewService();
    const latLng = new google.maps.LatLng(lat, lng);

    streetViewService.getPanorama(
      { location: latLng, radius: 50 },
      (data, status) => {
        if (status === google.maps.StreetViewStatus.OK) {
          this.initStreetView(lat, lng);
        } else {
          this.showStreetView = false;
        }
      }
    );
  }

  addDtPinsToMap() {
    for (let dt of this.dtsForMap) {
      this.addCustomPin(
        dt.id,
        dt.latitude,
        dt.longitude,
        AdvancedMapPinType.Dt,
        0,
        dt.clusterCount
      );
    }
  }

  addBuildingsPinsToMap() {
    for (let bd of this.buildingsForMap) {
      this.addCustomPin(
        bd.id,
        bd.latitude,
        bd.longitude,
        AdvancedMapPinType.Building,
        bd.connectedCustomers,
        bd.clusterCount
      );
    }
  }

  addPolesPinsToMap() {
    if (!this.advancedMapClustering.useClusteringPoles) {
      for (let pl of this.polesForMap) {
        this.addPoleMarker(
          pl.latitude,
          pl.longitude,
          pl.id,
          AdvancedMapPinType.Pole
        );
      }
    } else {
      for (let pl of this.polesForMap) {
        this.addCustomPin(
          pl.id,
          pl.latitude,
          pl.longitude,
          AdvancedMapPinType.Pole,
          pl.connectedCustomers,
          pl.clusterCount
        );
      }
    }
  }
  addPinsToMap() {
    for (let dt of this.dtsForMap) {
      this.addCustomPin(
        dt.id,
        dt.latitude,
        dt.longitude,
        AdvancedMapPinType.Dt,
        0,
        dt.clusterCount
      );
    }
    for (let bd of this.buildingsForMap) {
      this.addCustomPin(
        bd.id,
        bd.latitude,
        bd.longitude,
        AdvancedMapPinType.Building,
        bd.connectedCustomers,
        bd.clusterCount
      );
    }
    if (!this.advancedMapClustering.useClusteringPoles) {
      for (let pl of this.polesForMap) {
        this.addPoleMarker(
          pl.latitude,
          pl.longitude,
          pl.id,
          AdvancedMapPinType.Pole
        );
      }
    } else {
      for (let pl of this.polesForMap) {
        this.addCustomPin(
          pl.id,
          pl.latitude,
          pl.longitude,
          AdvancedMapPinType.Pole,
          pl.connectedCustomers,
          pl.clusterCount
        );
      }
    }
  }

  // full street view opened by dragging the pegman, shows our X button while it is open
  onMapInitialized(map: google.maps.Map) {
    const streetView = map.getStreetView();
    streetView.addListener('visible_changed', () =>
      this.ngZone.run(() => (this.fullStreetViewVisible = streetView.getVisible()))
    );
  }

  closeFullStreetView() {
    this.map.googleMap?.getStreetView().setVisible(false);
  }

  onZoomChanged() {
    const currentZoom = this.map.googleMap?.getZoom();
    if (
      currentZoom !== undefined &&
      currentZoom !== null &&
      this.defaultConfig.zoom != currentZoom
    ) {
      this.defaultConfig.zoom = currentZoom;
    }

    // if (this.defaultConfig.zoom < 19) {
    //   this.advancedMapClustering = new AdvancedMapClustering(true);
    // }
    // else {
    //   this.advancedMapClustering = new AdvancedMapClustering(false);
    // }

    this.updateClustering(this.defaultConfig.zoom);
  }

  private updateClustering(zoom: number) {
    this.advancedMapClustering = new AdvancedMapClustering(true);

    // All non-clustered
    if (zoom > 18) {
      this.advancedMapClustering = new AdvancedMapClustering(false);
      // Dts
    } else if (zoom == 18) {
      this.advancedMapClustering.useClusteringDts = false;
      this.advancedMapClustering.useClusteringPoles = false;
      this.advancedMapClustering.useClusteringSubstations = false;
      // Poles
    } else if (zoom == 17) {
      this.advancedMapClustering.useClusteringPoles = false;
      // All clustered
    } else {
      this.advancedMapClustering = new AdvancedMapClustering(true);
    }
  }

  getMapFullDetails(assetId: number, type: AdvancedMapPinType) {
    this.selectedMapAssetType = type;
    this.buildingMapDetails = undefined;
    this.poleMapDetails = undefined;
    this.dtMapDetails = undefined;

    switch (this.selectedMapAssetType) {
      case AdvancedMapPinType.Ts:
        break;
      case AdvancedMapPinType.Ss:
        break;

      case AdvancedMapPinType.Dt:
        this.getDtMapFullDetails(assetId);
        break;

      case AdvancedMapPinType.Building:
        this.getBuildingMapFullDetails(assetId);
        break;

      case AdvancedMapPinType.Pole:
        this.getPoleMapFullDetails(assetId);
        break;

      case AdvancedMapPinType.CimTransmissionStation:
        this.getCimSubstationMapFullDetails(assetId);
        break;

      case AdvancedMapPinType.CimInjectionSubstation:
        this.getCimSubstationMapFullDetails(assetId);
        break;

      case AdvancedMapPinType.CimDistributionSubstation:
        this.getCimSubstationMapFullDetails(assetId);
        break;
    }
  }

  getCimSubstationMapFullDetails(id: number) {
    this.taggedSubstationService.getMapDetails(id).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.poleMapDetails = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_: any) => {
        this.toastr.error('Error occured');
      },
    });
  }

  getPoleMapFullDetails(id: number) {
    this.poleService.getMapDetails(id).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.poleMapDetails = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  getBuildingMapFullDetails(id: number) {
    this.buildingService.getMapDetails(id).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.buildingMapDetails = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  getDtMapFullDetails(id: number) {
    this.dtService.getMapDetails(id).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.dtMapDetails = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  getBatchMapFullDetails(id: number) {
    this.batchObjService.getMapDetails(id).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.batchObjectDetails = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  closeMapDetailsModal() {
    this.selectedMapAssetType = undefined;
  }

  openImageModal(imageUrl: string) {
    this.selectedImageUrl = imageUrl;
    const modalElement = new bootstrap.Modal(
      document.getElementById('imageModal')
    );
    modalElement.show();
  }

  getZoomScaledValue(minValue:number, maxValue:number, defaultZoomLevel: number): number {
    const minZoom = 17;
    const maxZoom = 20;

    const coefficient = (defaultZoomLevel - minZoom) / (maxZoom - minZoom);
    return minValue + coefficient * (maxValue - minValue);
  }

  connectAssets(obj: any) {
    if (!this.advancedMapClustering.useClusteringPoles) {
      this.advancedMapService.getConnectedAssets(obj).subscribe({
        next: (response) => {
          const linesResponse = response.body.data;
          for (const line of linesResponse) {
            const path = [
              new google.maps.LatLng(line.parentLatitude, line.parentLongitude),
              new google.maps.LatLng(line.childLatitude, line.childLongitude),
            ];

            let polyline: any;
            let shouldDisplayPolyline: boolean = false;
            if (
              line.connectionType === 'Building' &&
              !this.advancedMapClustering.useClusteringBuildings
            ) {
              shouldDisplayPolyline = true;
              polyline = new google.maps.Polyline({
                ...this.mapPolylineOptions,
                path,
                map: this.linesVisible['lv'] ? this.map.googleMap! : null,
              });
              this.lineLayerPolylines['lv'].push(polyline);
            }
            if (
              line.connectionType === 'Pole' &&
              !this.advancedMapClustering.useClusteringPoles
            ) {
              shouldDisplayPolyline = true;
              polyline = new google.maps.Polyline({
                strokeColor: '#FFC800',
                strokeOpacity: 1.0,
                strokeWeight: this.getZoomScaledValue(3, 6, this.defaultConfig.zoom),
                path,
                map: this.linesVisible['lv'] ? this.map.googleMap! : null,
              });
              this.lineLayerPolylines['lv'].push(polyline);
            }

            if (shouldDisplayPolyline) {
              polyline.addListener('mouseover', () => {
                const distance = google.maps.geometry.spherical.computeLength(
                  polyline.getPath()
                );
                const distanceInMeters = distance.toFixed(2);
                const midpoint = this.getPolylineMidpoint(path);

                const contentString = `
                <div style="
                font-size: 14px;
                overflow: hidden;
                background: white;
                border-radius: 8px;
                padding: 4px 4px 0 4px;
                font-weight: 500;
                color: #333;
                display: inline-block;
                text-align: center;
                ">
                ${distanceInMeters} m
                </div>
                `;

                this.polylineInfoWindow = new google.maps.InfoWindow({
                  content: contentString,
                  position: midpoint,
                  headerDisabled: true,
                  disableAutoPan: true,
                });
                this.polylineInfoWindow.open(this.map.googleMap);
              });

              polyline.addListener('mouseout', () => {
                this.polylineInfoWindow.close();
              });
              this.polylineObjects.push(polyline);
            }
          }
        },
      });
    }
  }

  connectCimAssets(obj: any) {
    if (!this.advancedMapClustering.useClusteringPoles) {
      this.advancedMapService.getConnectedCimAssets(obj).subscribe({
        next: (response) => {
          const linesResponse = response.body.data;
          for (const line of linesResponse) {
            const path = [
              new google.maps.LatLng(line.parentLatitude, line.parentLongitude),
              new google.maps.LatLng(line.childLatitude, line.childLongitude),
            ];

            let polyline: any;
            let shouldDisplayPolyline: boolean = false;
            if (
              line.connectionType === 'Building' &&
              !this.advancedMapClustering.useClusteringBuildings
            ) {
              shouldDisplayPolyline = true;
              polyline = new google.maps.Polyline({
                ...this.mapPolylineOptions,
                path,
                map: this.linesVisible['lv'] ? this.map.googleMap! : null,
              });
              this.lineLayerPolylines['lv'].push(polyline);
            } else if (
              line.connectionType === 'Pole' &&
              !this.advancedMapClustering.useClusteringPoles
            ) {
              shouldDisplayPolyline = true;
              polyline = new google.maps.Polyline({
                strokeColor: '#FFC800',
                strokeOpacity: 1.0,
                strokeWeight: this.getZoomScaledValue(3, 6, this.defaultConfig.zoom),
                path,
                map: this.linesVisible['lv'] ? this.map.googleMap! : null,
              });
              this.lineLayerPolylines['lv'].push(polyline);
            }

            if (shouldDisplayPolyline) {
              polyline.addListener('mouseover', () => {
                const distance = google.maps.geometry.spherical.computeLength(
                  polyline.getPath()
                );
                const distanceInMeters = distance.toFixed(2);
                const midpoint = this.getPolylineMidpoint(path);

                const contentString = `
                <div style="
                font-size: 14px;
                overflow: hidden;
                background: white;
                border-radius: 8px;
                padding: 4px 4px 0 4px;
                font-weight: 500;
                color: #333;
                display: inline-block;
                text-align: center;
                ">
                ${distanceInMeters} m
                </div>
                `;

                this.polylineInfoWindow = new google.maps.InfoWindow({
                  content: contentString,
                  position: midpoint,
                  headerDisabled: true,
                  disableAutoPan: true,
                });
                this.polylineInfoWindow.open(this.map.googleMap);
              });

              polyline.addListener('mouseout', () => {
                this.polylineInfoWindow.close();
              });
              this.polylineObjects.push(polyline);
            }
          }
        },
      });
    }
  }

  private getPolylineMidpoint(path: google.maps.LatLng[]): google.maps.LatLng {
    if (path.length < 2) {
      return path[0];
    }

    const totalLength = google.maps.geometry.spherical.computeLength(path);
    let accumulated = 0;

    for (let i = 0; i < path.length - 1; i++) {
      const p1 = path[i];
      const p2 = path[i + 1];
      const segmentLength =
        google.maps.geometry.spherical.computeDistanceBetween(p1, p2);

      if (accumulated + segmentLength >= totalLength / 2) {
        const ratio = (totalLength / 2 - accumulated) / segmentLength;
        return google.maps.geometry.spherical.interpolate(p1, p2, ratio);
      }

      accumulated += segmentLength;
    }

    return path[path.length - 1];
  }

  closeThemeMenu() {
    this.themeMenuOpen = false;
  }

  toggleThemeMenu() {
    if (this.showPopup) this.showPopup = false;
    this.themeMenuOpen = !this.themeMenuOpen;
  }

  selectTheme(theme: MapThemeUI) {
    const mapTypeId = this.mapOptions.mapTypeId;
    // this.selectedTheme = MAP_THEMES.find((t) => t.key == config.mapTheme);
    this.selectedTheme = theme;
    this.mapOptions = theme.mapOptions;
    this.mapOptions.mapTypeId = mapTypeId;
    this.themeMenuOpen = false;
  }

  mapTypeToggle(e: any) {
    if (
      this.selectedTheme.mapOptions.mapTypeId ==
        google.maps.MapTypeId.SATELLITE ||
      this.selectedTheme.mapOptions.mapTypeId == google.maps.MapTypeId.HYBRID
    ) {
      this.selectedTheme.mapOptions.mapTypeId = google.maps.MapTypeId.ROADMAP;
      this.mapOptions.mapTypeId = google.maps.MapTypeId.ROADMAP;
    } else {
      this.selectedTheme.mapOptions.mapTypeId = google.maps.MapTypeId.HYBRID;
      this.mapOptions.mapTypeId = google.maps.MapTypeId.HYBRID;
    }
  }

  checkIfPoleIsOnMap(latitude: number, longitude: number) {
    return this.polesForMap.some(
      (pole) => pole.latitude == latitude && pole.longitude == longitude
    );
  }

  openFilter() {
    if (this.filterOpened) {
      this.filterOpened = false;
      this.searchOpened = false;
      this.searchIconVisible = true;
      return;
    }
    this.mapFilter = new AdvancedMapFilter();
    this.filterOpened = true;
    this.searchOpened = false;
    this.searchIconVisible = true;
  }

  closeFilterClicked(val: boolean) {
    if (val) this.filterOpened = false;
  }
  openSearch() {
    if (this.searchOpened) {
      this.searchOpened = false;
      this.searchIconVisible = true;
      this.filterOpened = false;
      return;
    }
    this.filterOpened = false;
    this.searchOpened = true;
    this.searchIconVisible = false;
  }
  applyFilterClicked(val: boolean) {
    // single cim substation in the filter centers on the substation
    if (this.hasCimDataIntegration && this.mapFilter.selectedCimSubstations.length == 1)
      this.mapFilter.mapFilterSingle.cimSubstationId = this.mapFilter.selectedCimSubstations[0];
    if (val) this.applyFilter();
    this.filterOpened = false;
  }

  closeSearchClicked(val: boolean) {
    if (val) {
      this.searchOpened = false;
      this.searchIconVisible = true;
    }
  }

  toggleAnalyticsTemplate() {
    this.analyticsOpened = !this.analyticsOpened;
    if (this.analyticsOpened) {
      this.getAssetCounts();
    }
  }

  getAssetCounts() {
    var obj = {
      areaIds: this.mapFilter.selectedAreas,
      dtIds: this.mapFilter.selectedDts,
      showAllNewEntries: !this.permissionService.isCustomerNewEntryBreakdownAllowed,
      subGeographicalRegionIds: this.mapFilter.selectedSubGeographicalRegions,
      substationIds: this.mapFilter.selectedCimSubstations,
    };
    this.getBuildingsCount(obj);
    this.getCustomersCount(obj);
    this.getPolesCount(obj);
    if (this.hasCimDataIntegration) {
      this.getCimCounts({
        subGeographicalRegionIds: this.mapFilter.selectedSubGeographicalRegions,
        substationIds: this.mapFilter.selectedCimSubstations,
      });
    } else {
      this.getDtsCount(obj);
      this.getTsCount(obj);
      this.getSubstationsCount(obj);
      this.getFeedersCount(obj);
    }
  }

  getCimCounts(filterObject: any) {
    this.advancedMapService.getCimCounts(filterObject).subscribe({
      next: (data) => {
        const counts = data.body.data;
        this.analyticsCounts.cimSsCounts = Object.entries<any>(counts.substationCounts ?? {}).map(([name, ss]) => ({
          name,
          count: ss.count,
          color: ss.color,
        }));
        this.analyticsCounts.feederAnalytics.count = counts.acLines;
        this.analyticsCounts.deviceAnalytics.count = counts.equipment;

        this.analyticsCounts.cimSsCounts.forEach((ss) => {
          const index = this.analyticsData.findIndex((x) => x.key === ss.name);
          if (index >= 0) {
            this.analyticsData[index].share = ss.count;
            this.analyticsColors[index] = ss.color;
          } else {
            const equipmentIndex = this.analyticsData.findIndex((x) => x.key === 'ADVANCED_MAP.EQUIPMENT');
            this.analyticsData.splice(equipmentIndex, 0, { key: ss.name, share: ss.count });
            this.analyticsColors.splice(equipmentIndex, 0, ss.color);
          }
        });
        this.analyticsColors = [...this.analyticsColors];
        this.analyticsData = [...this.analyticsData];

        this.setAnalyticsShare('ADVANCED_MAP.FEEDERS', counts.acLines);
        this.setAnalyticsShare('ADVANCED_MAP.EQUIPMENT', counts.equipment);
      },
      error: (error) => console.log(error.statusText),
    });
  }

  private setAnalyticsShare(key: string, value: number) {
    const item = this.analyticsData.find((x) => x.key === key);
    if (item) {
      item.share = value;
      this.analyticsData = [...this.analyticsData];
    }
  }

  getCimDtsCount(dts: any) {
    this.utilityService.get(this.utilityId).subscribe({
      next: (response) => {
        if (response.body?.status == 200 || response?.body?.status == 'OK') {
          this.utilityAcronym = response?.body?.data?.acronym ?? '';
          if (this.utilityAcronym.toLocaleLowerCase() == 'ekedp') {
            this.substationTemplateService.getAll(this.utilityId).subscribe({
              next: (response: any) => {
                if (response.body?.status == 200 || response?.body?.status == 'OK') {
                  const templates = response?.body?.data ?? [];
                  this.dtSubstationTemplateId = templates.find((t: any) => t.className === 'Distribution Substation')?.id;
                  this.filter = new Filter(this.utilityId, this.dtSubstationTemplateId);
                  this.taggedSubstationService.getAll(this.filter).subscribe({
                    next: (response: any) => {
                      if (response.body?.status === 200 || response.body?.status === 'OK') {
                        this.dtCimSubstationsCount = response?.body?.data?.count;
                        // this.analyticsCounts.dtAnalytics.count += this.dtCimSubstationsCount;
                        if (dts) {
                          dts.share += this.dtCimSubstationsCount;
                          this.analyticsData = [...this.analyticsData];
                        }
                      }
                    }
                  });
                }
              }
            })
          }
        }
      }
    });
  }

  getBuildingsCount(filterObject: any) {
    this.advancedMapService.getBuildingsCount(filterObject).subscribe({
      next: (data) => {
        this.analyticsCounts.buildingAnalytics.count = data.body.data;
        const buildings = this.analyticsData.find((x) => x.key === 'COMMON.BUILDING.PLURAL');
        if (buildings) {
          buildings.share = data.body.data;
          this.analyticsData = [...this.analyticsData];
        }
      },
      error: (error) => console.log(error.statusText),
    });
  }

  getCustomersCount(filterObject: any) {
    this.advancedMapService.getCustomersCount(filterObject).subscribe({
      next: (data) => {
        this.analyticsCounts.customerAnalytics.count = data.body.data;
        const customers = this.analyticsData.find((x) => x.key === 'COMMON.CUSTOMER.PLURAL');
        if (customers) {
          customers.share = data.body.data;
          this.analyticsData = [...this.analyticsData];
        }
      },
      error: (error) => console.log(error.statusText),
    });
  }

  getDtsCount(filterObject: any) {
    this.advancedMapService.getDtsCount(filterObject).subscribe({
      next: (data) => {
        this.analyticsCounts.dtAnalytics.count = data.body.data;
        this.analyticsCounts.deviceAnalytics.count = data.body.data;
        let dts = this.analyticsData.find(
          (x) => x.key === 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.DISTRIBUTION_SUBSTATION'
        );
        if (dts) {
          dts.share = data.body.data;
          this.analyticsData = [...this.analyticsData];
        }

        let devices = this.analyticsData.find((x) => x.key === 'ADVANCED_MAP.EQUIPMENT');
        if (devices) {
          devices.share = data.body.data;
          this.analyticsData = [...this.analyticsData];
        }

        // For EKEDP only
        // this.getCimDtsCount(dts);
      },
      error: (error) => console.log(error.statusText),
    });


  }

  getPolesCount(filterObject: any) {
    this.advancedMapService.getPolesCount(filterObject).subscribe({
      next: (data) => {
        this.analyticsCounts.poleAnalytics.count = data.body.data;
        const poles = this.analyticsData.find((x) => x.key === 'COMMON.POLE.PLURAL');
        if (poles) {
          poles.share = data.body.data;
          this.analyticsData = [...this.analyticsData];
        }
      },
      error: (error) => console.log(error.statusText),
    });
  }

  getFeedersCount(filterByObject: any) {
    this.advancedMapService.getFeedersCount(filterByObject).subscribe({
      next: (data: any) => {
        this.analyticsCounts.feederAnalytics.count = data.body.data;
        const feeders = this.analyticsData.find((x) => x.key === 'ADVANCED_MAP.FEEDERS');
        if (feeders) {
          feeders.share = data.body.data;
          this.analyticsData = [...this.analyticsData];
        }
      },
      error: (error: any) => console.log(error.statusText),
    });
  }

  getSubstationsCount(filterByObject: any) {
    this.advancedMapService.getSubstationsCount(filterByObject).subscribe({
      next: (data: any) => {
        this.analyticsCounts.substationAnalytics.count = data.body.data;
        const ss = this.analyticsData.find(
          (x) => x.key === 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.INJECTION_SUBSTATION'
        );
        if (ss) {
          ss.share = data.body.data;
          this.analyticsData = [...this.analyticsData];
        }
      },
      error: (error: any) => console.log(error.statusText),
    });
  }

  getTsCount(filterByObject: any) {
    this.advancedMapService.getTsCount(filterByObject).subscribe({
      next: (data: any) => {
        this.analyticsCounts.tsAnalytics.count = data.body.data;
        const ts = this.analyticsData.find(
          (x) => x.key === 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.TRANSMISSION_STATION'
        );
        if (ts) {
          ts.share = data.body.data;
          this.analyticsData = [...this.analyticsData];
        }
      },
      error: (error: any) => console.log(error.statusText),
    });
  }

  getDevicesCounts(filterByObject: any) {
    this.advancedMapService.getDevicesCount(filterByObject).subscribe({
      next: (data: any) => {
        this.analyticsCounts.deviceAnalytics.count = data.body.data;
      },
      error: (error: any) => console.log(error.statusText),
    });
  }

  filterByObject(obj: AssetDropdownOption) {
    this.mapFilter = new AdvancedMapFilter();
    if (obj.dtIds != null && obj.dtIds != undefined && obj.dtIds.length > 0) {
      this.mapFilter.selectedDts = obj.dtIds;
      // IS (option 2) search: only used to center the map on the substation, map data is still filtered by its dts
      if (this.isNetworkAsset && this.option == 2 && obj.id) this.mapFilter.mapFilterSingle.substationId = obj.id;
      this.applyFilter();
    } else if (obj.cimSubstationIds != null && obj.cimSubstationIds != undefined && obj.cimSubstationIds.length > 0) {
      this.mapFilter.selectedCimSubstations = obj.cimSubstationIds;
      // single cim substation search (template / slrn) centers on the substation, ac lines keep the old behaviour
      if (!this.isCimAcLine && obj.cimSubstationIds.length == 1) this.mapFilter.mapFilterSingle.cimSubstationId = obj.cimSubstationIds[0];
      this.applyFilter();
    } else {
      if (obj.buildingIds) {
        this.mapFilter.selectedBuildings = obj.buildingIds;
        this.mapFilter.isSingle = false;
      }
      if (obj.buildingId) {
        this.mapFilter.mapFilterSingle.buildingId = obj.buildingId ?? 0;
        this.mapFilter.isSingle = true;
      }
      if (obj.dtId) {
        this.mapFilter.mapFilterSingle.dtId = obj.dtId ?? 0;
        this.mapFilter.isSingle = true;
      }
      if (obj.poleId) {
        this.mapFilter.mapFilterSingle.poleId = obj.poleId ?? 0;
        this.mapFilter.isSingle = true;
      }
      if (obj.substationId) {
        this.mapFilter.mapFilterSingle.cimSubstationId = obj.substationId ?? 0;
        this.mapFilter.isSingle = true;
      }
      this.applyFilter();
    }

    this.searchDropdownOptionsVisible = false;
  }

  getCoordinatesFromSearch(coords: Coordinates) {
    this.mapFilter = new AdvancedMapFilter();
    this.defaultConfig.coordinates = {
      latitude: coords.latitude,
      longitude: coords.longitude,
    };
  }

  getTypeShort(type: any) {
    if (type == 'LvPole') return 'LV';
    if (type == 'MvPole') return 'MV';
    if (type == 'HvPole') return 'HV';
    return '';
  }
  getColor(type: any) {
    if (type == 'LvPole') return '#FFC800';
    if (type == 'MvPole') return '#94D02C';
    if (type == 'HvPole') return '#F06BFF';
    return '#FFC800';
  }
  getImgageByType(type: any) {
    if (type == 'LvPole') return '../../assets/icons/adv-map-pin-lv-pole.svg';
    if (type == 'MvPole') return '../../assets/icons/adv-map-pin-mv-pole.svg';
    if (type == 'HvPole') return '../../assets/icons/adv-map-pin-hv-pole.svg';
    return '';
  }
  addCustomPinBatchObject(
    id: number,
    lat: number,
    lng: number,
    type: any,
    connectedCustomers?: number,
    clusterCount?: number
  ) {
    const componentRef = this.viewContainerRef.createComponent(
      AdvancedMapPinComponent
    );
    componentRef.instance.inputIsCluster =
      this.advancedMapClustering.useClusteringBatchObjects;
    //PIN STYLES
    if (type == 'DtGroundMounted' || type == 'DtPoleMounted') {
      componentRef.instance.inputColor = '#005EFF';
      componentRef.instance.inputImg = '../../assets/icons/adv-map-pin-dt.svg';
      componentRef.instance.inputType = 'DT';
      componentRef.instance.inputImg = '../../assets/icons/adv-map-pin-dt.svg';
      componentRef.instance.inputClusterCount = clusterCount?.toString() ?? '';
    } else if (type == 'Building') {
      componentRef.instance.inputText = '';
      componentRef.instance.inputColor = '#009E51';
      componentRef.instance.inputImg =
        '../../assets/icons/adv-map-pin-building.svg';
      componentRef.instance.inputClusterCount = clusterCount?.toString() ?? '';
    } else if (type == 'LvPole' || type == 'MvPole' || type == 'HvPole') {
      var color = this.getColor(type);
      componentRef.instance.inputColor = color;
      componentRef.instance.inputImg = this.getImgageByType(type);
      componentRef.instance.inputClusterCount = clusterCount?.toString() ?? '';
      if (type == 'HvPole') {
        componentRef.instance.isHvPole = true;
      }
      this.addPoleClusterPin(
        this.getPoleLayer(color),
        componentRef.location.nativeElement
      );
    } else if (type == 'TransmissionStation') {
      componentRef.instance.inputImg =
        '../../assets/icons/transmission-station.svg';
      componentRef.instance.inputColor = '#7A28FF';
      componentRef.instance.inputType = 'TS';
      componentRef.instance.inputImg =
        '../../assets/icons/transmission-station.svg';
      componentRef.instance.inputClusterCount = clusterCount?.toString() ?? '';
    } else if (type == 'InjectionSubstation') {
      componentRef.instance.inputImg =
        '../../assets/icons/injection-substations.svg';

      componentRef.instance.inputColor = '#ED6B00';
      componentRef.instance.inputType = 'IS';
      componentRef.instance.inputImg =
        '../../assets/icons/injection-substations.svg';
      componentRef.instance.inputClusterCount = clusterCount?.toString() ?? '';
    }

    const overlay = new google.maps.OverlayView();

    overlay.onAdd = () => {
      const panes = overlay.getPanes();
      const element = componentRef.location.nativeElement;
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      panes!.overlayMouseTarget.appendChild(element);

      element.addEventListener('click', async (event: any) => {
        event?.stopPropagation();

        if (this.activeInfoWindow) {
          this.activeInfoWindow.close();
          this.activeInfoWindow = null;
        }
        this.checkAndInitStreetView(lat, lng);

        if (!this.advancedMapClustering.useClusteringBatchObjects) {
          const modalComponentRef = createComponent(MapInfoWindowComponent, {
            environmentInjector: this.appRef.injector,
          });

          modalComponentRef.instance.generatedObjectUrl.subscribe(
            (url: string) => {
              this.generatedObjectUrl = url;
            }
          );

          modalComponentRef.instance.assetId = id;
          modalComponentRef.instance.type = AdvancedMapPinType.BatchObject;
          this.popupAssetId = id;
          this.appRef.attachView(modalComponentRef.hostView);
          modalComponentRef.changeDetectorRef.detectChanges();

          // Display full details on button click
          modalComponentRef.instance.actionClicked.subscribe(() => {
            this.getBatchMapFullDetails(id);
          });

          // Close modal on X click
          modalComponentRef.instance.closeWindow.subscribe(() => {
            if (this.activeInfoWindow) {
              this.activeInfoWindow.close();
              modalComponentRef.destroy();
              this.activeInfoWindow = null;
            }
          });

          // Copy coordinates click
          modalComponentRef.instance.copyCoordinates.subscribe(() => {
            const coordinates = `${lat}, ${lng}`;
            navigator.clipboard
              .writeText(coordinates)
              .then(() => {})
              .catch((err) => {});
          });
          modalComponentRef.instance.imageClicked.subscribe((res) => {
            this.openImageModal(res);
          });
          this.appRef.attachView(modalComponentRef.hostView);
          const domElem = (modalComponentRef.hostView as EmbeddedViewRef<any>)
            .rootNodes[0] as HTMLElement;

          document.body.appendChild(domElem);
          await this.waitForElementToRender(domElem);

          const infoWindow = new google.maps.InfoWindow({
            content: domElem,
            position: { lat, lng },
            headerDisabled: true,
            disableAutoPan: false,
          });

          infoWindow.open(this.map.googleMap);
          this.activeInfoWindow = infoWindow;
          domElem.remove();

          google.maps.event.addListener(this.map.googleMap!, 'click', () => {
            if (this.activeInfoWindow) {
              this.hideStreetView();
              this.activeInfoWindow.close();
              modalComponentRef.destroy();
              this.activeInfoWindow = null;
            }
          });
        } else {
          this.defaultConfig.zoom += 4;
          this.defaultConfig.coordinates.latitude = lat;
          this.defaultConfig.coordinates.longitude = lng;
        }
      });
    };

    overlay.draw = () => {
      const projection = overlay.getProjection();
      if (!projection) return;

      const position = new google.maps.LatLng(lat, lng);
      const point = projection.fromLatLngToDivPixel(position);
      if (!point) return;

      const div = componentRef.location.nativeElement;
      div.style.left = `${point.x - div.offsetWidth / 2}px`;
      div.style.top = `${point.y - div.offsetHeight}px`;
      div.style.visibility = 'visible';
    };

    overlay.onRemove = () => {
      if (
        componentRef.location &&
        componentRef.location.nativeElement?.parentNode
      ) {
        componentRef.location.nativeElement.parentNode.removeChild(
          componentRef.location.nativeElement
        );
      }
      componentRef.destroy();
    };

    overlay.setMap(this.map.googleMap!);
    this.pinOverlays.push(overlay);
  }

  closeGeneratedModal() {
    this.generatedObjectUrl = null;
  }

  onSearchType(e: MouseEvent) {
    e.stopPropagation();
    this.searchTypeOpened = !this.searchTypeOpened;
  }

  onSearchTypeSelected(type: AdvancedMapSearchType) {
    this.searchTypeOpened = false;
    this.searchType = type;
    this.searchText = '';
    this.changeSearchTypeLabel(type);
    this.search(type);
  }

  onCimTemplateSelected(template: SubstationTemplateDto) {
    this.searchTypeOpened = false;
    this.searchType = AdvancedMapSearchType.AssetName_CimSubstation;
    this.searchText = '';
    this.searchTypeLabel = template.className;
    this.restoreDefaults();
    this.isCimSubstationTemplate = true;
    this.selectedCimSubstationTemplateId = template.id ?? 0;
    this.searchDropdownOptionsVisible = true;
    this.getOptions();
  }

  onCimAcLineTypeSelected(lineType: { id: number; name: string }) {
    this.searchTypeOpened = false;
    this.searchType = AdvancedMapSearchType.AssetName_CimAcLine;
    this.searchText = '';
    this.searchTypeLabel = lineType.name;
    this.restoreDefaults();
    this.isCimAcLine = true;
    this.selectedCimAcLineType = lineType.id;
    this.searchDropdownOptionsVisible = true;
    this.getOptions();
  }

  private search(type: AdvancedMapSearchType) {
    switch (type) {
      case AdvancedMapSearchType.AssetName_TS:
        this.restoreDefaults();
        this.option = 0;
        this.isNetworkAsset = true;
        this.searchDropdownOptionsVisible = true;
        this.getOptions();
        break;
      case AdvancedMapSearchType.AssetName_F33:
        this.restoreDefaults();
        this.option = 1;
        this.isNetworkAsset = true;
        this.searchDropdownOptionsVisible = true;
        this.getOptions();
        break;
      case AdvancedMapSearchType.AssetName_IS:
        this.restoreDefaults();
        this.option = 2;
        this.isNetworkAsset = true;
        this.searchDropdownOptionsVisible = true;
        this.getOptions();
        break;
      case AdvancedMapSearchType.AssetName_F11:
        this.restoreDefaults();
        this.option = 3;
        this.isNetworkAsset = true;
        this.searchDropdownOptionsVisible = true;
        this.getOptions();
        break;
      case AdvancedMapSearchType.AssetName_DS:
        this.restoreDefaults();
        this.option = 4;
        this.isNetworkAsset = true;
        this.searchDropdownOptionsVisible = true;
        this.getOptions();
        break;
      case AdvancedMapSearchType.AssetSlrn_Building:
        this.restoreDefaults();
        this.isBuildingSlrn = true;
        this.searchDropdownOptionsVisible = true;
        this.getOptions();
        break;
      case AdvancedMapSearchType.AssetSlrn_DS:
        this.restoreDefaults();
        this.isDtSlrn = true;
        this.searchDropdownOptionsVisible = true;
        this.getOptions();
        break;
      case AdvancedMapSearchType.AssetSlrn_LVPole:
        this.restoreDefaults();
        this.isLvPoleSlrn = true;
        this.searchDropdownOptionsVisible = true;
        this.getOptions();
        break;
      case AdvancedMapSearchType.AssetSlrn_Meter:
        this.restoreDefaults();
        this.isMeterSlrn = true;
        this.searchDropdownOptionsVisible = true;
        this.getOptions();
        break;
      case this.advancedMapSearchType.MeterNumber:
        this.restoreDefaults();
        this.isMeterNumber = true;
        this.searchDropdownOptionsVisible = true;
        this.getOptions();
        break;
      case this.advancedMapSearchType.AccountNumber:
        this.restoreDefaults();
        this.isAccNo = true;
        this.searchDropdownOptionsVisible = true;
        this.getOptions();
        break;
      case this.advancedMapSearchType.Location:
        this.restoreDefaults();
        this.isLocation = true;
        this.searchDropdownOptionsVisible = true;
        if (!this.autocompleteInitialized) {
          setTimeout(() => {
            this.initAutocomplete();
          }, 300);
        }
    }
  }

  private changeSearchTypeLabel(type: AdvancedMapSearchType) {
    switch (type) {
      case AdvancedMapSearchType.Location:
        this.searchTypeLabel = 'COMMON.LOCATION';
        break;
      case AdvancedMapSearchType.AssetName_Building:
        this.searchTypeLabel = 'ADVANCED_MAP.SEARCH_TYPE_LABELS.BUILDING_NAME';
        break;
      case AdvancedMapSearchType.AssetName_DS:
        this.searchTypeLabel = 'ADVANCED_MAP.SEARCH_TYPE_LABELS.DS_NAME';
        break;
      case AdvancedMapSearchType.AssetName_F33:
        this.searchTypeLabel = 'ADVANCED_MAP.SEARCH_TYPE_LABELS.MAIN_FEEDER_NAME';
        break;
      case AdvancedMapSearchType.AssetName_F11:
        this.searchTypeLabel = 'ADVANCED_MAP.SEARCH_TYPE_LABELS.SEC_FEEDER_NAME';
        break;
      case AdvancedMapSearchType.AssetName_IS:
        this.searchTypeLabel = 'ADVANCED_MAP.SEARCH_TYPE_LABELS.IS_NAME';
        break;
      case AdvancedMapSearchType.AssetName_LVPole:
        this.searchTypeLabel = 'ADVANCED_MAP.SEARCH_TYPE_LABELS.LV_POLE_NAME';
        break;
      case AdvancedMapSearchType.AssetName_TS:
        this.searchTypeLabel = 'ADVANCED_MAP.SEARCH_TYPE_LABELS.TS_NAME';
        break;
      case AdvancedMapSearchType.AssetSlrn_Building:
        this.searchTypeLabel = 'ADVANCED_MAP.SEARCH_TYPE_LABELS.BUILDING_SLRN';
        break;
      case AdvancedMapSearchType.AssetSlrn_DS:
        this.searchTypeLabel = this.hasCimDataIntegration
          ? 'ADVANCED_MAP.SEARCH_TYPE_LABELS.SUBSTATION_SLRN'
          : 'ADVANCED_MAP.SEARCH_TYPE_LABELS.DS_SLRN';
        break;
      case AdvancedMapSearchType.AssetSlrn_LVPole:
        this.searchTypeLabel = 'ADVANCED_MAP.SEARCH_TYPE_LABELS.LV_POLE_SLRN';
        break;
      case AdvancedMapSearchType.AssetSlrn_Meter:
        this.searchTypeLabel = 'ADVANCED_MAP.SEARCH_TYPE_LABELS.METER_SLRN';
        break;
      case AdvancedMapSearchType.AccountNumber:
        this.searchTypeLabel = 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.ACCOUNT_NUMBER';
        break;
      case AdvancedMapSearchType.MeterNumber:
        this.searchTypeLabel = 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.METER_NUMBER';
        break;
      default:
        this.searchTypeLabel = 'COMMON.SEARCH_TYPE';
        break;
    }
  }

  getOptions() {
    if (this.isNetworkAsset) {
      this.dashboardService.getNetworkAssetOptions(this.option).subscribe({
        next: (data) => {
          if (data?.body?.data) {
            this.stations = data?.body?.data;
            this.filteredStations = this.stations;
          } else {
            this.stations = [];
            this.filteredStations = [];
          }
        },
        error: (error) => console.log(error.statusText),
      });
    } else if (this.isLocation) {
      this.locationInput.nativeElement.value = '';
    } else if (this.isAccNo) {
      this.getAccountNumbers();
    } else if (this.isLvPoleSlrn) {
      this.getLvPoleSlrns();
    } else if (this.isDtSlrn) {
      this.getDtSlrns();
    } else if (this.isBuildingSlrn) {
      this.getBuildingSlrns();
    } else if (this.isMeterNumber) {
      this.getMeterNumbers();
    } else if (this.isMeterSlrn) {
      this.getMeterSlrns();
    } else if (this.isCimSubstationTemplate) {
      this.getCimSubstationsForTemplate();
    } else if (this.isCimAcLine) {
      this.getCimAcLinesForType();
    }
  }

  restoreDefaults(restoreAll: boolean = false) {
    clearTimeout(this.searchDebounceTimer);
    this.searchDropdownOptionsVisible = false;
    this.isLocation = false;
    this.isMeterNumber = false;
    this.isBuildingSlrn = false;
    this.isDtSlrn = false;
    this.isLvPoleSlrn = false;
    this.isAccNo = false;
    this.isNetworkAsset = false;
    this.isCimSubstationTemplate = false;
    this.isCimAcLine = false;
    this.autocompleteInitialized = false;
    this.stations = [];
    this.filteredStations = [];
    if (restoreAll) {
      this.searchType = this.advancedMapSearchType.None;
      this.searchIconVisible = true;
      this.searchOpened = false;
      this.searchTypeOpened = false;
      // this.getDefaultCoordinates(true);
    }
  }

  private getAccountNumbers() {
    this.advancedMapService
      .searchAccountNumber({ count: this.count, prefix: this.searchText })
      .subscribe({
        next: (data) => {
          if (data?.body?.data) {
            this.stations = data?.body?.data;
            this.filteredStations = [...this.stations];
          } else {
            this.stations = [];
            this.filteredStations = [];
          }
        },
        error: (error) => console.log(error.statusText),
      });
  }

  private getDtSlrns() {
    const search$ = this.hasCimDataIntegration
      ? this.advancedMapService.searchCimSubstationSlrn({ count: this.count, prefix: this.searchText })
      : this.advancedMapService.searchDtSlrn({ count: this.count, prefix: this.searchText });
    search$
      .subscribe({
        next: (data) => {
          if (data?.body?.data) {
            this.stations = data?.body?.data;
            this.filteredStations = [...this.stations];
          } else {
            this.stations = [];
            this.filteredStations = [];
          }
        },
        error: (error) => console.log(error.statusText),
      });
  }

  private getBuildingSlrns() {
    this.advancedMapService
      .searchBuildingSlrn({ count: this.count, prefix: this.searchText })
      .subscribe({
        next: (data) => {
          if (data?.body?.data) {
            this.stations = data?.body?.data;
            this.filteredStations = [...this.stations];
          } else {
            this.stations = [];
            this.filteredStations = [];
          }
        },
        error: (error) => console.log(error.statusText),
      });
  }

  private getMeterNumbers() {
    this.advancedMapService
      .searchMeterNumber({ count: this.count, prefix: this.searchText })
      .subscribe({
        next: (data) => {
          if (data?.body?.data) {
            this.stations = data?.body?.data;
            this.filteredStations = [...this.stations];
          } else {
            this.stations = [];
            this.filteredStations = [];
          }
        },
        error: (error) => console.log(error.statusText),
      });
  }

  private getMeterSlrns() {
    this.advancedMapService
      .searchMeterSlrn({ count: this.count, prefix: this.searchText })
      .subscribe({
        next: (data) => {
          if (data?.body?.data) {
            this.stations = data?.body?.data;
            this.filteredStations = [...this.stations];
          } else {
            this.stations = [];
            this.filteredStations = [];
          }
        },
        error: (error) => console.log(error.statusText),
      });
  }

  private getLvPoleSlrns() {
    this.advancedMapService
      .searchLvPoleSlrn({ count: this.count, prefix: this.searchText })
      .subscribe({
        next: (data) => {
          if (data?.body?.data) {
            this.stations = data?.body?.data;
            this.filteredStations = [...this.stations];
          } else {
            this.stations = [];
            this.filteredStations = [];
          }
        },
        error: (error) => console.log(error.statusText),
      });
  }

  private getCimSubstationsForTemplate() {
    this.cimSubstationService
      .getAllForSelectMap({ templateId: this.selectedCimSubstationTemplateId, searchTerm: this.searchText })
      .subscribe({
        next: (data: any) => {
          if (data?.body?.data) {
            this.stations = data.body.data.map((x: any) => new AssetDropdownOption({ name: x.name, cimSubstationIds: [x.id] }));
            this.filteredStations = [...this.stations];
          } else {
            this.stations = [];
            this.filteredStations = [];
          }
        },
        error: (error: any) => console.log(error.statusText),
      });
  }

  private getCimAcLinesForType() {
    this.acLineSegmentService
      .getAllForSelectMap({ acLineType: this.selectedCimAcLineType, searchTerm: this.searchText })
      .subscribe({
        next: (data: any) => {
          if (data?.body?.data) {
            // an ac line with no outgoing substations has nothing to show on the map
            this.stations = data.body.data
              .filter((x: any) => x.cimSubstationIds?.length > 0)
              .map((x: any) => new AssetDropdownOption({ name: x.name, cimSubstationIds: x.cimSubstationIds }));
            this.filteredStations = [...this.stations];
          } else {
            this.stations = [];
            this.filteredStations = [];
          }
        },
        error: (error: any) => console.log(error.statusText),
      });
  }

  filterStations(): void {
    this.filteredStations = this.stations.filter((station) =>
      station.name.toLowerCase().includes(this.searchText.toLowerCase())
    );
    // network asset options don't take a search term, so refetching would only undo the local filter
    if (this.isNetworkAsset) return;
    clearTimeout(this.searchDebounceTimer);
    this.searchDebounceTimer = setTimeout(() => this.getOptions(), 500);
  }

  initAutocomplete() {
    const input = this.locationInput.nativeElement;

    const autocomplete = new google.maps.places.Autocomplete(input, {
      types: ['geocode'],
    });

    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place = autocomplete.getPlace();
        if (
          place &&
          place.formatted_address &&
          place.geometry &&
          place.geometry.location
        ) {
          this.searchText = place.formatted_address;

          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          const coords = new Coordinates(lat, lng);

          this.getCoordinatesFromSearch(coords);
        }
      });
    });
  }

  closeFullDetailsModal() {
    const modalEl = document.getElementById('exampleModalCenter');
    const modal = bootstrap.Modal.getInstance(modalEl);
    modal?.hide();
  }

  setMapType(type: 'roadmap' | 'hybrid') {
    this.currentMapType = type;

    this.mapOptions = {
      ...this.mapOptions,
      mapTypeId: type,
    };
  }

  loadMapConfiguration() {
    const mapConfig = localStorage.getItem('mapConfiguration');
    if (mapConfig) {
      try {
        const config = JSON.parse(mapConfig) as MapConfiguration;
        const mapTheme = config.mapTheme || 'retro';
        const mapTypeId = config.mapType || 'hybrid';

        this.selectedTheme = MAP_THEMES.find((t) => t.key == mapTheme);
        // create new object instead of referencing theme.mapOptions
        this.mapOptions = { ...this.selectedTheme.mapOptions, mapTypeId };
        this.currentMapType = this.mapOptions.mapTypeId as any;

        this.defaultConfig.coordinates.latitude = config.latitude;
        this.defaultConfig.coordinates.longitude = config.longitude;
        this.defaultConfig.zoom = config.zoom!;

        // force update on actual google map instance
        if (this.map?.googleMap) {
          this.map.googleMap.setOptions(this.mapOptions);
          if (mapTypeId) this.map.googleMap.setMapTypeId(mapTypeId as any);
        }

        if (this.defaultConfig.zoom < 19) {
          this.advancedMapClustering = new AdvancedMapClustering(true);
        }
      } catch (e) {
        console.error('Error loading map configuration:', e);
        this.setDefaultMapSettings();
      }
    } else {
      this.setDefaultMapSettings();
    }
  }

  setDefaultMapSettings() {
    this.selectedTheme = MAP_THEMES.find((t) => t.key == 'retro');
    this.mapOptions = this.selectedTheme.mapOptions;
    this.mapOptions.mapTypeId = 'hybrid';
    this.getCoordinatesWhenNoConfiguration();
  }

  openLvPolesMapModal(lvPolePupup: PolePopupDto) {
    this.removePinsFromModal();
    this.removeLinesFromModal();

    this.modalMapConfig.coordinates.latitude = lvPolePupup.latitude;
    this.modalMapConfig.coordinates.longitude = lvPolePupup.longitude;

    const modalElement = document.getElementById('assetModalMap');
    const modal = new bootstrap.Modal(modalElement!);

    this.modalMapOptions = {
      ...this.mapOptions,
      streetViewControl: false,
      fullscreenControl: false,
      mapTypeControl: false,
      zoomControl: false,
      gestureHandling: 'none',
      disableDefaultUI: true,
    };

    modal.show();

    modalElement!.addEventListener(
      'shown.bs.modal',
      () => {
        setTimeout(() => {
          if (this.modalMap?.googleMap) {
            google.maps.event.trigger(this.modalMap.googleMap, 'resize');
            this.modalMap.googleMap.setCenter({
              lat: this.modalMapConfig.coordinates.latitude!,
              lng: this.modalMapConfig.coordinates.longitude!,
            });
          }
          this.getLvPolesDataForModal(lvPolePupup);
        }, 50);
      },
      { once: true }
    );

    modalElement!.addEventListener('hidden.bs.modal', () => {
      this.locationChanged = false;
      this.removePinsFromModal();
      this.removeLinesFromModal();
      this.modifiedAssetIds = [];
      this.clearAllTempConnectionLines();
    });
  }

  getLvPolesDataForModal(lvPolePupup: PolePopupDto) {
    this.lvPolePopup = lvPolePupup;

    this.bounds = {
      minLatitude: lvPolePupup.latitude! - 0.001,
      maxLatitude: lvPolePupup.latitude! + 0.001,
      minLongitude: lvPolePupup.longitude! - 0.001,
      maxLongitude: lvPolePupup.longitude! + 0.001,
    };

    const poleObj = {
      ...this.bounds,
      zoom: this.modalMapConfig.zoom,
      utilityId: this.utilityId,
      filter: this.mapFilter,
      type: AdvancedMapPinType.Pole,
      advancedMapClustering: this.advancedMapClustering,
    };

    this.advancedMapService.getMapData(poleObj).subscribe({
      next: (response) => {
        const responseData = response.body?.data;
        if (responseData) {
          this.assetsForModal = responseData.filter(
            (pole: any) => pole.type === 'Pole'
          );
          this.addLvPolesPinsToModalMap();
          this.connectAssetsForModal(poleObj);

          setTimeout(() => {
            google.maps.event.trigger(this.modalMap.googleMap!, 'resize');
            this.modalMap.googleMap!.setCenter({
              lat: this.modalMapConfig.coordinates.latitude!,
              lng: this.modalMapConfig.coordinates.longitude!,
            });
          }, 50);
        } else {
          this.toastr.info('No assets found for the current view.');
        }
      },
      error: (_) => {
        this.toastr.error('Error loading assets.');
      },
    });
  }

  addCustomPinToModal(
    id: number,
    lat: number,
    lng: number,
    type: AdvancedMapPinType
  ) {
    const componentRef = this.viewContainerRef.createComponent(
      AdvancedMapPinComponent
    );

    if (type === AdvancedMapPinType.Pole) {
      componentRef.instance.isCluster = false;
      componentRef.instance.inputColor = '#FFC800';
      componentRef.instance.inputImg =
        '../../assets/icons/adv-map-pin-lv-pole.svg';
    }

    const overlay = new google.maps.OverlayView();

    overlay.onAdd = () => {
      const panes = overlay.getPanes();
      const element = componentRef.location.nativeElement;
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      panes!.overlayMouseTarget.appendChild(element);

      let offsetX = 0;
      let offsetY = 0;

      if (id === this.lvPolePopup.id) {
        element.addEventListener('mousedown', (event: MouseEvent) => {
          event.stopPropagation();
          event.preventDefault();

          const projection = overlay.getProjection();
          const mapDiv = this.modalMap.googleMap!.getDiv();
          const rect = mapDiv.getBoundingClientRect();

          const pos = projection.fromLatLngToDivPixel(
            new google.maps.LatLng(lat, lng)
          );

          offsetX = event.clientX - rect.left - pos!.x;
          offsetY = event.clientY - rect.top - pos!.y;

          const onMove = (moveEvent: MouseEvent) => {
            const projection = overlay.getProjection();
            if (!projection) return;

            const mouseX = moveEvent.clientX - rect.left;
            const mouseY = moveEvent.clientY - rect.top;

            const pixelX = mouseX - offsetX;
            const pixelY = mouseY - offsetY;

            const latLng = projection.fromDivPixelToLatLng(
              new google.maps.Point(pixelX, pixelY)
            );
            if (!latLng) return;

            const point = projection.fromLatLngToDivPixel(latLng);
            element.style.left = `${point!.x - element.offsetWidth / 2}px`;
            element.style.top = `${point!.y - element.offsetHeight}px`;
            this.updateTempConnectionLines(id, latLng.lat(), latLng.lng());
            this.updateRegularConnectionLines(id, latLng.lat(), latLng.lng());
          };

          const onUp = (upEvent: MouseEvent) => {
            const projection = overlay.getProjection();
            if (!projection) return;

            const mouseX = upEvent.clientX - rect.left;
            const mouseY = upEvent.clientY - rect.top;

            const pixelX = mouseX - offsetX;
            const pixelY = mouseY - offsetY;

            const latLng = projection.fromDivPixelToLatLng(
              new google.maps.Point(pixelX, pixelY)
            );

            if (latLng) {
              const updatedAsset = this.assetsForModal.find((a) => a.id === id);
              if (updatedAsset) {
                updatedAsset.latitude = latLng.lat();
                updatedAsset.longitude = latLng.lng();
                updatedAsset.assetId = id;
                updatedAsset.assetType = AdvancedMapPinType.Pole;

                this.updateTempConnectionLines(id, latLng.lat(), latLng.lng());

                overlay.setMap(null);

                this.bounds = {
                  minLatitude:
                    Math.min(...this.assetsForModal.map((p) => p.latitude)) -
                    0.001,
                  maxLatitude:
                    Math.max(...this.assetsForModal.map((p) => p.latitude)) +
                    0.001,
                  minLongitude:
                    Math.min(...this.assetsForModal.map((p) => p.longitude)) -
                    0.001,
                  maxLongitude:
                    Math.max(...this.assetsForModal.map((p) => p.longitude)) +
                    0.001,
                };

                this.locationChanged = true;
                this.removePinsFromModal();
                this.addLvPolesPinsToModalMap();
              }
            }

            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
          };

          document.addEventListener('mousemove', onMove);
          document.addEventListener('mouseup', onUp);
        });
      } else {
        element.addEventListener('click', () => {
          if (id !== this.lvPolePopup.id) {
            this.onPinClick(id);
          }
        });
      }
    };

    overlay.draw = () => {
      const projection = overlay.getProjection();
      if (!projection) return;

      const position = new google.maps.LatLng(lat, lng);
      const point = projection.fromLatLngToDivPixel(position);
      if (!point) return;

      const div = componentRef.location.nativeElement;
      div.style.left = `${point.x - div.offsetWidth / 2}px`;
      div.style.top = `${point.y - div.offsetHeight}px`;
      div.style.visibility = 'visible';

      div.style.cursor = id === this.lvPolePopup.id ? 'grab' : 'default';
    };

    overlay.onRemove = () => {
      if (componentRef.location?.nativeElement?.parentNode) {
        componentRef.location.nativeElement.parentNode.removeChild(
          componentRef.location.nativeElement
        );
      }
      componentRef.destroy();
    };

    overlay.setMap(this.modalMap.googleMap!);
    this.modalPinOverlays.push(overlay);
  }

  addLvPolesPinsToModalMap() {
    this.assetsForModal.forEach((pole) => {
      this.addCustomPinToModal(
        pole.id,
        pole.latitude,
        pole.longitude,
        AdvancedMapPinType.Pole
      );
    });
  }

  connectAssetsForModal(obj: any) {
    this.advancedMapService.getConnectedAssets(obj).subscribe({
      next: (response) => {
        const linesResponse = response.body.data;
        for (const line of linesResponse) {
          const path = [
            new google.maps.LatLng(line.parentLatitude, line.parentLongitude),
            new google.maps.LatLng(line.childLatitude, line.childLongitude),
          ];

          const polyline = new google.maps.Polyline({
            strokeColor: '#FFC800',
            strokeOpacity: 1.0,
            strokeWeight: this.getZoomScaledValue(3, 6, this.modalMapConfig.zoom),
            path,
            map: this.modalMap.googleMap!,
          });

          const startId = (line as any).parentId;
          const endId = (line as any).childId;

          (polyline as any).startId = startId;
          (polyline as any).endId = endId;

          this.modalPolylineObjects.push(polyline);
        }
      },
      error: (_) => {
        this.toastr.error('Error loading connected assets for modal.');
      },
    });
  }

  reloadModalMap() {
    this.removePinsFromModal();
    this.removeLinesFromModal();

    this.addLvPolesPinsToModalMap();

    const poleObj = {
      ...this.bounds,
      zoom: this.modalMapConfig.zoom,
      utilityId: this.utilityId,
      filter: this.mapFilter,
      type: AdvancedMapPinType.Pole,
      advancedMapClustering: this.advancedMapClustering,
    };

    this.connectAssetsForModal(poleObj);

    if (this.modalMap?.googleMap) {
      setTimeout(() => {
        google.maps.event.trigger(this.modalMap.googleMap!, 'resize');
        this.modalMap.googleMap!.setCenter({
          lat: this.modalMapConfig.coordinates.latitude!,
          lng: this.modalMapConfig.coordinates.longitude!,
        });
      }, 50);
    }
  }

  private removeLinesFromModal() {
    for (let polyline of this.modalPolylineObjects) {
      polyline.setMap(null);
    }
    this.modalPolylineObjects = [];
  }

  private removePinsFromModal() {
    for (let overlay of this.modalPinOverlays) {
      overlay.setMap(null);
    }
    this.modalPinOverlays = [];
  }

  onSaveClicked() {
    const updatedAsset = this.assetsForModal.find(
      (a) => a.id === this.lvPolePopup.id
    );
    updatedAsset.newConnectionIds = this.modifiedAssetIds;
    updatedAsset.assetId = this.lvPolePopup.id;
    updatedAsset.assetType = AdvancedMapPinType.Pole;

    if (updatedAsset) {
      this.advancedMapService.updateAssetLocation(updatedAsset).subscribe({
        next: (_) => {
          this.toastr.success('Location saved successfully.');
          this.locationChanged = false;
          this.lvPolePopup.latitude = updatedAsset.latitude;
          this.lvPolePopup.longitude = updatedAsset.longitude;
          this.modifiedAssetIds = [];
          this.getData();
        },
        error: (_) => {
          this.toastr.error('Error saving location.');
        },
      });
    }
  }

  onPinClick(poleId: number) {
    const isOriginalConnection = this.modalPolylineObjects.some(
      (line) =>
        ((line as any).startId === this.lvPolePopup.id &&
          (line as any).endId === poleId) ||
        ((line as any).startId === poleId &&
          (line as any).endId === this.lvPolePopup.id)
    );

    if (isOriginalConnection) {
      this.toastr.info(
        'This pole is part of an original connection and cannot be modified.'
      );
      return;
    }

    if (this.modifiedAssetIds.includes(poleId)) {
      this.pendingPoleId = poleId;
      this.confirmationMode = 'remove';
    } else {
      this.pendingPoleId = poleId;
      this.confirmationMode = 'connect';
    }
  }

  confirmConnectOrRemove() {
    if (!this.pendingPoleId) return;
    const startPole = this.assetsForModal.find(
      (a) => a.id === this.lvPolePopup.id
    )!;
    const endPole = this.assetsForModal.find(
      (a) => a.id === this.pendingPoleId
    )!;
    if (
      this.confirmationMode === 'connect' &&
      !this.modifiedAssetIds.includes(this.pendingPoleId)
    ) {
      this.modifiedAssetIds.push(this.pendingPoleId);
      const startLatLng = new google.maps.LatLng(
        startPole.latitude,
        startPole.longitude
      );
      const endLatLng = new google.maps.LatLng(
        endPole.latitude,
        endPole.longitude
      );
      this.addTempConnectionLine(
        startLatLng,
        endLatLng,
        startPole.id,
        endPole.id
      );
    } else if (this.confirmationMode === 'remove') {
      this.modifiedAssetIds = this.modifiedAssetIds.filter(
        (id) => id !== this.pendingPoleId
      );
      this.removeTempConnectionLine(this.lvPolePopup.id, this.pendingPoleId);
    }

    this.pendingPoleId = null;
    this.confirmationMode = null;
  }

  cancelConnect() {
    this.pendingPoleId = null;
    this.confirmationMode = null;
  }

  addTempConnectionLine(
    startLatLng: google.maps.LatLng,
    endLatLng: google.maps.LatLng,
    startId: number,
    endId: number
  ) {
    const line = new google.maps.Polyline({
      path: [startLatLng, endLatLng],
      strokeColor: '#00BFFF',
      strokeOpacity: 0.7,
      strokeWeight: this.getZoomScaledValue(3, 6, this.modalMapConfig.zoom),
      map: this.modalMap.googleMap!,
      icons: [
        {
          icon: { path: 'M 0,-1 0,1', strokeOpacity: 1, scale: 4 },
          offset: '0',
          repeat: '10px',
        },
      ],
    });

    (line as any).startId = startId;
    (line as any).endId = endId;

    this.tempConnectionLines.push(line);
  }

removeTempConnectionLine(startPoleId: number, endPoleId: number) {
  this.tempConnectionLines = this.tempConnectionLines.filter((line) => {
    const lineStartId = (line as any).startId;
    const lineEndId = (line as any).endId;

    const isMatch =
      (lineStartId === startPoleId && lineEndId === endPoleId) ||
      (lineStartId === endPoleId && lineEndId === startPoleId);

    if (isMatch) {
      line.setMap(null);
      return false;
    }
    return true;
  });
}

  clearAllTempConnectionLines() {
    this.tempConnectionLines.forEach((line) => line.setMap(null));
    this.tempConnectionLines = [];
  }

  updateTempConnectionLines(
    movedPoleId: number,
    newLat: number,
    newLng: number
  ) {
    const newLatLng = new google.maps.LatLng(newLat, newLng);

    this.tempConnectionLines.forEach((line) => {
      const path = line.getPath();
      if ((line as any).startId === movedPoleId) path.setAt(0, newLatLng);
      if ((line as any).endId === movedPoleId) path.setAt(1, newLatLng);
    });
  }

  updateRegularConnectionLines(
    movedPoleId: number,
    newLat: number,
    newLng: number
  ) {
    const newLatLng = new google.maps.LatLng(newLat, newLng);

    this.modalPolylineObjects.forEach((line) => {
      const path = line.getPath();
      if ((line as any).startId === movedPoleId) path.setAt(0, newLatLng);
      if ((line as any).endId === movedPoleId) path.setAt(1, newLatLng);
    });
  }
}
